<template>
  <div
    class="main-box"
    v-if="!$route.query.view"
    @blur="changeIndex = -1"
    @mousemove="changeResize($event)"
    @mouseup="endResize()">
    <!-- モーダル START -->
    <ModalCreate
      ref="create"
      :companyColumnSetting="companyColumnSetting"
      :options="options"
      :select_manages="select_manages"
      :blacklistSwitch="blacklistSwitch"
      :currentManage="currentManage"
      :isDuplicateSeekerFlag="isDuplicateSeekerFlag"
      :isGetRoboTalk="isGetRoboTalk"
      :PCTRLLOG="CTRLLOG"
      :pulldownOptionsByColumnId="pulldownOptionsByColumnId"
      :getOptionsForColumn="getOptionsForColumn"
  />
    <ModalEdit 
      ref="edit"
      :isDuplicateSeekerFlag="isDuplicateSeekerFlag"
      :isGetRoboTalk="isGetRoboTalk"
    />
    <ModalEditDate @saveDate="saveDate" ref="editdate" :PCTRLLOG="CTRLLOG"/>
    <!-- 一括アクション -->
    <ModalBulkAction
      :isShowModal="isOpenModalBulkAction"
      :archiveSwitch="archiveSwitch"
      :bulkSeekerList="bulkSeekerList"
      :select_manages="select_manages"
      :user="user"
      :blacklistSwitch="blacklistSwitch"
      :recruitmentFlows="recruitmentFlows"
      @cancel="cancelModalBulkAction"
      @clickBulkSendEmail="clickBulkSendEmail"
      @clickBulkSendSMS="clickBulkSendSMS"
      @clickBulkManage="clickBulkManage"
      @archiveSeeker="archiveSeeker"
      @acknowledgedSeeker="acknowledgedSeeker"
      @logicalDeleteSeeker="logicalDeleteSeeker"
      @emptyBulkSeekerList="emptyBulkSeekerList"
      @clickBulkStageStatus="handleBulkStageStatus"
    />
    <!-- メールモーダル -->
    <ModalSelectEmail
      :isShowModal="isOpenModalSelectEmail"
      :selectEmailSeeker="selectEmailSeeker"
      :user="user"
      @cancel="cancelModalSelectEmail"
      @openSendEmailMenu="openSendEmailMenu"
      @openSendSMSMenu="openSendSMSMenu"/>
    <!-- メッセージモーダル -->
    <ModalMessageList
      :isShowModal="isOpenModalMessage"
      :selectSeeker="selectEmailSeeker"
      :messageList="chatLogs"
      @cancel="cancelModalMessage"
      @openSendEmailMenu="openSendEmailMenu"
      @openSendSMSMenu="openSendSMSMenu"/>
    <ModalStage
      :isShowModal="isModalStage"
      :changeRecruitmentFlow="changeRecruitmentFlow"
      :sk="tempSeeker"
      :stgs="tempStg"
      @cancel="changeModalStage"
      v-if="isModalStage"
      :PCTRLLOG="CTRLLOG"
    >
    </ModalStage>
    <ModalStatus
      :isShowModal="isModalStatus"
      :changeRecruitmentFlow="changeRecruitmentFlow"
      :sk="tempSeeker"
      :stss="tempSts"
      @cancel="changeModalStatus"
      v-if="isModalStatus"
      :PCTRLLOG="CTRLLOG"
    >
    </ModalStatus>
    <!-- 応募者詳細画面 -->
    <ModalDetailSeeker
      :isShowModal="isModalDetailSeeker"
      :companyColumnSetting="companyColumnSetting"
      :recruitmentFlows="recruitmentFlows"
      :select_manages="select_manages"
      :default_manage="default_manage"
      :detailManage="detailManage"
      :sk="tempSeeker"
      :options="options"
      :sexTypes="sexTypes"
      :updateSeeker="updateSeeker"
      :getScoutFlg="getScoutFlg"
      :getPath="getPath"
      :getAge="getAge"
      :getHref="getHref"
      :editdate="$refs.editdate"
      :changeModalDelete="changeModalDelete"
      :changeModalSetDate="changeModalSetDate"
      :changeModalChangeDate="changeModalChangeDate"
      :edit="$refs.edit"
      :getDate="getDate"
      :changeRecruitmentFlow="changeRecruitmentFlow"
      :getRecruitmentFlowStatus="getRecruitmentFlowStatus"
      :updateCustomColumnByCell="updateCustomColumnByCell"
      :isLastCol="isLastCol"
      :createCustomColumn="createCustomColumn"
      :isColInSkInfo="isColInSkInfo"
      :getInterviewDate="getInterviewDate"
      :viewAnswer="viewAnswer"
      :getRecruitmentFlowActions="getRecruitmentFlowActions"
      :saveDate="saveDate"
      :pageUpdate="pageUpdate"
      :duplicatedApplicants="duplicatedApplicants"
      :changeModalDetailSeeker="changeModalDetailSeeker"
      :formatCreatedAt="formatCreatedAt"
      :dataForMailAction="dataForMailAction"
      :user="user"
      :isDuplicateSeekerFlag="isDuplicateSeekerFlag"
      :isGetRoboTalk="isGetRoboTalk"
      @cancel="changeModalDetailSeeker"
      @change-recruitment-flow="changeRecruitmentFlow"
      @open-action-check-modal="openActionCheckModal"
      @open-action-table-modal="openActionTableModal"
      v-if="isModalDetailSeeker"
      :PCTRLLOG="CTRLLOG"
      :pulldownOptionsByColumnId="pulldownOptionsByColumnId"
      :getOptionsForColumn="getOptionsForColumn"
      :handleSelectChange="handleSelectChange"
      @open-file="openFileModal"
    >
    </ModalDetailSeeker>
    <ModalStageStatus
      :isShowModal="isModalStageStatus"
      :changeRecruitmentFlow="changeRecruitmentFlow"
      :seekers="tempSeekers"
      :recruitmentFlows="recruitmentFlows"
      @cancel="changeModalStageStatus"
      v-if="isModalStageStatus"
      :PCTRLLOG="CTRLLOG">
    </ModalStageStatus>
    <!-- アクション確認画面 -->
    <ModalActionCheck
      ref="actchk"
      @delete-recruit-flow-action="deleteRecruitFlowAction"
      :PCTRLLOG="CTRLLOG"
    />
    <!-- アクション履歴確認画面 -->
    <ModalActionTable ref="acttbl"/>
    <ModalDelete
      ref="delete"
      :isShowModal="isOpenModalDelete"
      @deleteSeekerFile="deleteSeekerFile"
      @cancel="changeModalDelete"/>
    <!-- 回答閲覧 -->
    <ModalViewInterview
      ref="interview"
      :isShowModal="isViewDialogOpen"
      :user="user"
      :seeker="selectSeeker"
      :recruitmentFlows="recruitmentFlows"
      @update-recording-answer="updateRecordingAnswer"
      @update-recording-read-answer="updateRecordingReadAnswer"
      @close="viewClose"/>
    <!-- 面接日程調整 -->
    <ModalSetDate
      v-if="isModalSetDate"
      ref="set-date"
      :isShowModal="isModalSetDate"
      :user="user"
      :users="users"
      :seeker="selectSeeker"
      :chatbots="chatbots"
      :recordingInterviews="recordingInterviews"
      :options="ops"
      :emailTemplates="emailTemplates"
      :copyLink="copyLink"
      :bulk="false"
      :sendEmailToSeeker="sendEmailToSeeker"
      :sendLoadding="sendLoadding"
      :sendEmailTemplate="sendEmailTemplate"
      :changeEmailTemplate="changeEmailTemplate"
      :tempSaveEmail="tempSaveEmail"
      :helpMessage="helpMessage"
      :openEmailMenu="openEmailMenu"
      :calendarSettings="calendarSettingsDisplay"
      :archiveSwitch="archiveSwitch"
      :blacklistSwitch="blacklistSwitch"
      :orSwitch="orSwitch"
      :filtered="filtered"
      :seekersPages="seekersPages"
      :perPage="perPage"
      :currentManage="currentManage"
      :usersStatusAPI="usersStatusAPI"
      :isDuplicateSeekerFlag="isDuplicateSeekerFlag"
      :isGetRoboTalk="isGetRoboTalk"
      @cancel="changeModalSetDate"
      :PCTRLLOG="CTRLLOG"
    />

    <!-- モーダル：面接予定日作成 -->
    <ModalCreateInterviewDate
      v-if="isModalCreateDate"
      ref="createdate"
      :archiveSwitch="archiveSwitch"
      :blacklistSwitch="blacklistSwitch"
      :orSwitch="orSwitch"
      :filtered="filtered"
      :seekersPages="seekersPages"
      :perPage="perPage"
      :currentManage="currentManage"
      :chatbots="chatbots"
      :recordingInterviews="recordingInterviews"
      :options="ops"
      :emailTemplates="emailTemplates"
      :copyLink="copyLink"
      :sendEmailToSeeker="sendEmailToSeeker"
      :sendLoadding="sendLoadding"
      :sendEmailTemplate="sendEmailTemplate"
      :changeEmailTemplate="changeEmailTemplate"
      :tempSaveEmail="tempSaveEmail"
      :helpMessage="helpMessage"
      :openEmailMenu="openEmailMenu"
      :usersStatusAPI="usersStatusAPI"
      :info="createDateInfo"
      :seeker="selectSeeker"
      :isCardModalActive="isModalCreateDate"
      :isDuplicateSeekerFlag="isDuplicateSeekerFlag"
      :isGetRoboTalk="isGetRoboTalk"
      @closeEditPage="closeEditPage"
    />

    <ModalChangeDate
      v-if="isModalChangeDate"
      ref="change-date"
      :isShowModal="isModalChangeDate"
      :user="user"
      :users="users"
      :seeker="selectSeeker"
      :chatbots="chatbots"
      :recordingInterviews="recordingInterviews"
      :options="ops"
      :emailTemplates="emailTemplates"
      :copyLink="copyLink"
      :bulk="false"
      :sendEmailToSeeker="sendEmailToSeeker"
      :sendLoadding="sendLoadding"
      :sendEmailTemplate="sendEmailTemplate"
      :changeEmailTemplate="changeEmailTemplate"
      :tempSaveEmail="tempSaveEmail"
      :helpMessage="helpMessage"
      :openEmailMenu="openEmailMenu"
      :calendarSettings="calendarSettingsDisplay"
      :archiveSwitch="archiveSwitch"
      :blacklistSwitch="blacklistSwitch"
      :orSwitch="orSwitch"
      :filtered="filtered"
      :seekersPages="seekersPages"
      :perPage="perPage"
      :currentManage="currentManage"
      :interviewHistory="interviewHistory"
      :usersStatusAPI="usersStatusAPI"
      :isDuplicateSeekerFlag="isDuplicateSeekerFlag"
      :isGetRoboTalk="isGetRoboTalk"
      @cancel="changeModalChangeDate"
      @delete-recruit-flow-action="deleteRecruitFlowAction"
    />
   <!-- ファイルプレビューモーダル -->
    <FileModal
      :file="selectedFileModal"
      :isOpen="isFileModalOpen"
      @close="closeFileModal"
    />
   <!-- ファイルリスト表示用ポップオーバー -->
    <FileListPopover
      v-if="showingFileList"
      :files="currentSeekerFiles"
      :file="selectedFileModal"
      :style="popoverStyle"
      :sk="tempSeeker"
      @open-file="openFileModal"
      @close="closeFileListPopover"
      @mouseenter="clearHideTimeout"
      @mouseleave="startHideTimeout"
      :isopen="isFileModalOpen"
    />
   <!-- セル内容詳細表示用ポップオーバー -->
    <CellContentPopover
      v-if="showingCellContent && currentCellContent"
      :text="currentCellContent"
      :popover-style="cellPopoverStyle"
      @mouseenter="handlePopoverEnter"
      @mouseleave="handlePopoverLeave"
      @close="closeCellContentPopover"
    />


    <!-- 外部媒体情報 -->
    <div style="height: 100%; width: 100%; background: rgba(0, 0, 0, 0.5); position: absolute; z-index: 200; top: 0;" @click="isOpenOtherInfomation = false" v-if="isOpenOtherInfomation"></div>
    <transition name="right">
      <div class="slide-menu" style="position: absolute; top: 0; right: 0; height: 100%; width: 40%; min-width: 500px; background: #FEFEFE; padding: 16px; z-index: 201; overflow-y: scroll;" v-if="isOpenOtherInfomation">
        <h2 style="margin-bottom: 8px; font-weight: 600;"><span class="mdi mdi-cloud-sync" style="margin-right: 8px;"></span>外部媒体情報</h2>
        <div class="table-wrapper disp-scroll" style="height: calc(100% - 40px);">
          <table style="width: 100%; border-right: 1px lightgray solid; border-bottom: 1px lightgray solid; border-left: 1px lightgray solid;" v-if="tempOtherInfomation">
            <tr class="table-header">
              <th>項目</th>
              <th>内容</th>
            </tr>
            <tr v-for="t in getInfo(tempOtherInfomation[0].parameter)" :key="t + '-param'">
              <td style="width: 120px; vertical-align: middle; height: 50px; padding: 8px; text-align: left; font-size: 14px; border-right: 1px lightgray solid;">{{t}}</td>
              <td style="width: calc(100% - 60px); text-align: left; vertical-align: middle; white-space: pre-wrap; overflow-y: scroll; height: 80px; padding: 8px; font-size: 14px;">{{getContent(tempOtherInfomation[0].parameter, t)}}</td>
            </tr>
          </table>
        </div>
      </div>
    </transition>
    <!-- ヘッダー下のエリア -->
    <div class="top-menu" v-if="!isSeekerLoading">
      <div class="button-wrapper-tables tabs is-toggle is-small">
        <button v-for="manage in manages" :key="manage.pk" @click="changeManageid(manage.pk)" :class="{'is-primary': currentManage == manage.pk && !archiveSwitch}" class="button is-small" style="width: 100px; margin: 0px;"><span>{{ manage.name }}</span></button>
        <button @click="changeArchiveSwitch(true)" :class="{'is-primary': archiveSwitch}" class="button is-small" style="width: 100px; margin: 0px;"><span class="mdi mdi-chart-timeline">アーカイブ</span></button>
        <button @click="changeBlacklistSwitch(true)" :class="{'is-primary': blacklistSwitch}" class="button is-small" style="width: 100px; margin: 0px;"><span class="mdi mdi-stop-circle">採用フロー停止</span></button>
        <!--
          2024/01/16
          重複フラグ表示のON/OFFは一旦保留にして、更に表示を速くしたい要望が出てきたら使用する
          現状isDuplicateSeekerFlagがデフォルトtrueなので、falseにするかDBにも保存するかは要望受領後検討する
          ロボ会話履歴取得フラグも場合によっては画面上でON/OFFできるようにする
        -->
        <!-- <div class="duplicate-flag-wraper">
          <input class="is-small" type="checkbox" v-model="isDuplicateSeekerFlag" /><p class="duplicate-flag">応募者重複フラグ表示</p>
        </div> -->
      </div>
      <div class="button-wrapper-manage tabs is-toggle is-small">
        <button @click="$refs.create.isShowModal = true" :disabled="notAllowSeekerInfo" class="button -no1 is-small" v-if="!isSaving"><span class="mdi mdi-plus" style="margin-right: 5px;"></span>新規応募者</button>
        <!-- セル編集後、フォーカスが外れると保存されるので、全体的な保存ボタンは不要となった -->
        <!-- <button @click="save()" :disabled="notAllowSeekerInfo" class="button -no2 is-small" v-if="!isSaving"><span class="mdi mdi-content-save" style="margin-right: 5px;"></span>保存</button>
        <button class="button -no2 is-small" v-if="isSaving"><span class="mdi mdi-loading mdi-spin" style="margin-right: 5px;"></span>保存中です</button> -->
        <button @click="isOpenModalBulkAction = true" :disabled="notAllowSeekerInfo" class="button -no3 is-small" v-if="!isSaving"><span class="mdi mdi-checkbox-multiple-blank-outline" style="margin-right: 5px;"></span>一括アクション</button>
      </div>
      <!-- メニュー -->
      <div class="button-wrapper">
        <b-dropdown aria-role="list" position="is-bottom-left">
          <button :disabled="notAllowSeekerInfo" class="button is-small" type="button" slot="trigger">
              <template>
                  <b-icon icon="menu"></b-icon>
                  <span class="-left-8px">テーブル設定</span>
              </template>
              <b-icon icon="menu-down"></b-icon>
          </button>
          <b-dropdown-item @click="$emit('open-table-setting')" aria-role="listitem">
              <div class="media">
                  <b-icon class="media-left" icon="table-edit"></b-icon>
                  <div class="media-content">
                      <p><b>項目の追加・変更</b></p>
                      <small>応募者管理画面に表示する項目の並び替え・表示変更の設定を行います。</small>
                  </div>
              </div>
          </b-dropdown-item>
          <b-dropdown-item @click="$emit('open-create-manage-menu')" aria-role="listitem">
              <div class="media">
                  <b-icon class="media-left" icon="laptop"></b-icon>
                  <div class="media-content">
                      <p><b>応募者管理画面のタブ追加</b></p>
                      <small>応募者管理画面を追加します。</small>
                  </div>
              </div>
          </b-dropdown-item>
          <b-dropdown-item @click="$emit('open-modal-import-seeker', true, archiveSwitch, perPage, seekersPages, filtered, orSwitch, blacklistSwitch)" aria-role="listitem">
              <div class="media">
                  <b-icon class="media-left" icon="import"></b-icon>
                  <div class="media-content">
                      <p><b>インポート</b></p>
                      <small>CSV形式の応募者データをインポートします。</small>
                  </div>
              </div>
          </b-dropdown-item>
          <b-dropdown-item @click="$emit('open-export-modal')" aria-role="listitem" v-if="!isSaving">
              <div class="media">
                  <b-icon class="media-left" icon="export"></b-icon>
                  <div class="media-content">
                      <p><b>エクスポート</b></p>
                      <small>CSV形式の応募者データをエクスポートします。</small>
                  </div>
              </div>
          </b-dropdown-item>
          <b-dropdown-item @click="$emit('open-detail-sheet-setting')" aria-role="listitem">
              <div class="media">
                  <b-icon class="media-left" icon="export"></b-icon>
                  <div class="media-content">
                      <p><b>詳細シート作成</b></p>
                      <small>シートの作成を行います。</small>
                  </div>
              </div>
          </b-dropdown-item>
        </b-dropdown>

        <b-dropdown aria-role="list" position="is-bottom-left">
          <button :disabled="notAllowSeekerInfo" class="button is-small" type="button" slot="trigger">
              <template>
                  <b-icon icon="chart-timeline"></b-icon>
                  <span class="-left-8px">採用フロー設定</span>
              </template>
              <b-icon icon="menu-down"></b-icon>
          </button>
          <b-dropdown-item @click="$emit('open-flow-menu')" aria-role="listitem">
              <div class="media">
                  <b-icon class="media-left" icon="chart-timeline"></b-icon>
                  <div class="media-content">
                      <p><b>ステージ/ステータス/アクション設定</b></p>
                      <small>採用フローの内容設定を行います。</small>
                  </div>
              </div>
          </b-dropdown-item>
          <b-dropdown-item @click="$emit('open-email-template')" aria-role="listitem">
              <div class="media">
                  <b-icon class="media-left" icon="note-multiple-outline"></b-icon>
                  <div class="media-content">
                    <p><b>送付文章テンプレート</b></p>
                    <small>応募者へお送りするためのEmailとSMSの<br>テンプレートを作成できます。</small>
                  </div>
              </div>
          </b-dropdown-item>
          <b-dropdown-item @click="$emit('open-auto-flow-menu')" aria-role="listitem">
              <div class="media">
                  <b-icon class="media-left" icon="chart-timeline"></b-icon>
                  <div class="media-content">
                      <p><b>アクション自動化設定</b></p>
                      <small>採用フローの自動設定を行います。</small>
                  </div>
              </div>
          </b-dropdown-item>
          <b-dropdown-item @click="$emit('open-pause-auto-flow-setting')" aria-role="listitem" v-if="user.isAgent">
              <div class="media">
                  <b-icon class="media-left" icon="stop-circle"></b-icon>
                  <div class="media-content">
                      <p><b>採用フロー停止設定</b></p>
                      <small>採用フローの停止期間の設定を行います。</small>
                  </div>
              </div>
          </b-dropdown-item>
          <b-dropdown-item @click="$emit('open-applicant-blacklist')" aria-role="listitem" v-if="user.isAgent || user.permission == 0">
              <div class="media">
                  <b-icon class="media-left" icon="account-alert"></b-icon>
                  <div class="media-content">
                      <p><b>※管理者権限※　採用フロー停止応募者設定</b></p>
                      <small>採用フローを停止する応募者情報の設定を行います。</small>
                  </div>
              </div>
          </b-dropdown-item>
        </b-dropdown>
        <button @click="$emit('open-cloud-sync')" :disabled="notAllowSeekerInfo" class="button is-small"><b-icon class="media-left" icon="cloud-sync" style="margin-right: 10px;"></b-icon>外部媒体連携</button>
      </div>
    </div>
    <!-- モーダル END -->
    <div class="recruit-header" v-if="filtered.length > 0">
      <!-- フィルタタグ -->
      <div style="font-weight: 600; margin-left: 16px;"><span class="mdi mdi-filter" style="margin-right: 8px;"></span>Filter</div>
      <!-- 検索種別 -->
      <b-switch style="margin-left: 8px;" size="is-small" v-model="orSwitch">{{orSwitch ? 'OR' : 'AND'}}</b-switch>
      <template v-for="(f, i) in filtered">
        <!-- タグ -->
        <b-tag style="margin-left: 8px;" :key="i + '-param2'">
          {{f.name}}:
          <!-- カスタムカラム(自由入力) -->
          <template v-if="f.type==0 && f.type_custom_culumn==1">{{f.multipleData.length == 1 ? f.multipleData[0] : f.multipleData.length + "項目選択中"}}</template>
          <!-- カスタムカラム(選択肢) -->
          <template v-if="f.type==0 && f.type_custom_culumn==2">{{f.multipleData.length == 1 ? f.multipleData[0] : f.multipleData.length + "項目選択中"}}</template>
          <!-- カスタムカラム(日付) -->
          <template v-if="f.type==0 && f.type_custom_culumn==3">{{f.multipleData.length == 1 ? f.multipleData[0].replace(/-/g,'/') : "複数日付選択中"}}</template>
          <!-- 媒体 -->
          <template v-if="f.type==1">{{f.media}}</template>
          <!-- 生年月日 -->
          <template v-if="f.type==6">{{(f.fromAge ? f.fromAge + '歳' : '下限なし')}} - {{f.toAge ? (f.toAge + '歳') : '上限なし'}}</template>
          <!-- その他 -->
          <template v-if="f.type!=0&&f.type!=1&&f.type!=9&&f.type!=10&&f.type!=12&&f.type!=16&&f.type!=19&&f.type!=20&&f.type!=21&&f.type!=24&&f.type!=25&&f.data">{{f.data}}</template>
          <!-- 性別 -->
          <template v-if="f.type==9">{{sexTypes[Number(f.data)]}}</template>
          <!-- 状況 -->
          <template v-if="f.type==10">{{f.data !== null ? getProgressText(Number(f.data)) : '未設定'}}</template>
          <!-- 応募日 -->
          <template v-if="f.type==11">{{f.multipleData.length == 1 ? f.multipleData[0].replace(/-/g,'/') : "複数日付選択中"}}</template>
          <!-- 応募回数 -->
          <template v-if="f.type==12">{{f.data}}回</template>
          <!-- スカウト -->
          <template v-if="f.type==16">{{f.scout ? '送付済' : '未送付'}}</template>
          <!-- ステージ -->
          <template v-if="f.type==19">{{f.stage ? f.stage.name : 'ステージ未設定'}}</template>
          <!-- ステータス -->
          <template v-if="f.type==20">{{f.status ? f.status.name : 'ステータス未設定'}}</template>
          <!-- アクション -->
          <template v-if="f.type==21">{{f.action ? f.action.name : 'アクション未設定'}}{{f.action ? getSelectName(f.action.select) : ''}}</template>
          <!-- 面接予定日 -->
          <template v-if="f.type==22">{{f.multipleData.length == 1 ? f.multipleData[0].replace(/-/g,'/') : "複数日付選択中"}}</template>
          <!-- フラグ -->
          <template v-if="f.type==24">{{flgTypes[Number(f.data)]}}</template>
          <!-- ロボ会話 -->
          <template v-if="f.type==25">{{f.chatbot ? getChatBotName(f.chatbot) : 'ロボ未会話'}}</template>
          <!-- 管理ID -->
          <template v-if="f.type==30">{{f.applicant_id}}</template>
          <!-- ソート方法 -->
          <template v-if="f.sortAsc"> 昇順</template>
          <template v-if="f.sortDesc"> 降順</template>
          <!-- フィルタ編集 -->
          <span class="mdi mdi-filter" @click="changeIdxFilter=i"></span>
          <div style="position: absolute; width: auto; padding: 8px; top: 200px; background: #FEFEFE; color: #2c3e50; border: solid thin #ccc; z-index: 20001;" v-if="i==changeIdxFilter">
            <h2 style="padding: 8px; font-weight: 600;">{{f.name}}</h2>
            <!-- ソート -->
            <div class="tabs is-centered is-toggle is-small" style="margin-botton: 8px;" v-if="f.type!=0 && f.type!=1 && f.type!=14 && f.type!=15 && f.type!=18 && f.type!=19 && f.type!=20 && f.type!=21 && f.type!=24 && f.type!=25">
              <ul>
                <li :class="{'is-active': sortAsc}">
                  <a @click="sortAsc=true;sortDesc=false;">昇順</a>
                </li>
                <li :class="{'is-active': !sortAsc && !sortDesc}">
                  <a @click="sortAsc=false;sortDesc=false;">標準</a>
                </li>
                <li :class="{'is-active': sortDesc}">
                  <a @click="sortAsc=false;sortDesc=true;">降順</a>
                </li>
              </ul>
            </div>
            <!-- フィルター -->
            <input class="input is-small" style="width: 95%;" placeholder="フィルタを入力" v-model="filterWord"
              v-if="
                f.type!=0 &&   // カスタムカラム
                f.type!=1 &&   // 媒体
                f.type!=6 &&   // 生年月日
                f.type!=9 &&   // 性別
                f.type!=10 &&  // 状況
                f.type!=11 &&  // 応募日
                f.type!=12 &&  // 応募回数
                f.type!=16 &&  // スカウト
                f.type!=19 &&  // ステージ
                f.type!=20 &&  // ステータス
                f.type!=21 &&  // アクション
                f.type!=22 &&  // 面接予定日
                f.type!=24 &&  // フラグ
                f.type!=25 &&  // ロボ会話履歴
                f.type!=30     // 管理ID
                "
            />
            <!-- 管理ID -->
            <div style="display: flex; align-items: center;" v-if="f.type == 30">
              <b-numberinput size="is-small" style="margin-right: 8px;" :controls="false" v-model="filterWord"/>
            </div>
            <!-- 媒体 -->
            <v-select class="select-recruit"
              v-if="f.type == 1"
              v-model="filterMedia"
              :options="filterRecruitList"
              label="name" :reduce="rec => rec.name"
              :components="{Deselect: {render: createElement => createElement('span', '')}}"></v-select>
            <!-- 性別 -->
            <select class="select" v-model="filterWord" v-if="f.type == 9">
              <option v-for="(s, i) in sexTypes" :key="i + '-param3'" :value="i">{{s}}</option>
            </select>
            <!-- 状況 -->
            <select class="select" v-model="filterWord" v-if="f.type == 10">
              <option v-for="(op, i) in options" :key="i + '-param4'" :value="op.value">{{op.text}}</option>
            </select>
            <!-- 訪問回数 -->
            <select class="select" v-model="filterWord" v-if="f.type == 12">
              <option v-for="i in 5" :key="i + '-param5'" :value="i">{{i}}回</option>
            </select>
            <!-- 生年月日 -->
            <div style="display: flex; align-items: center;" v-if="f.type == 6">
              <b-numberinput size="is-small" style="margin-right: 8px;" :controls="false" v-model="fromAge"/>歳から
              <b-numberinput size="is-small" style="margin-left: 8px; margin-right: 8px;" :controls="false" v-model="toAge"/>歳まで
            </div>
            <!-- 応募日 -->
            <div v-if="f.type == 11">
              <div class="mdi mdi-loading mdi-spin mdi-24px" v-if="seekerFilterItems == null"></div>
              <div v-else class="filter-custom-free">
                <SelectTree :contents="multipleFilterDisplayDates"  :statusKey="'__select__'" :title="'すべて選択'"></SelectTree>
              </div>
            </div>
            <!-- スカウト -->
            <select class="select" v-model="filterScout" v-if="f.type == 16">
              <option v-for="(sc, i) in [false, true]" :key="i + '-param6'" :value="sc">{{sc ? '送付済' : '未送付'}}</option>
            </select>
            <!-- ステージ -->
            <v-select class="select-recruit"
              v-if="f.type == 19"
              v-model="filterStage"
              :options="recruitmentFlowStages"
              label="name"
              :components="{Deselect: {render: createElement => createElement('span', '')}}"></v-select>
            <!-- ステータス -->
            <v-select class="select-recruit"
              v-if="f.type == 20"
              v-model="filterStatus"
              :options="recruitmentFlowStatus"
              label="name"
              :components="{Deselect: {render: createElement => createElement('span', '')}}"></v-select>
            <!-- アクション -->
            <v-select class="select-recruit"
              v-if="f.type == 21"
              v-model="filterAction"
              :options="recruitmentFlowActions"
              label="name"
              :components="{Deselect: {render: createElement => createElement('span', '')}}"></v-select>
            <!-- SMS、Email時のアクション結果選択表示 type=0:Email type=1:SMS-->
            <div class="filter-sort block" v-if="f.type == 21 && filterAction">
              <b-radio v-model="filterAction.select" :native-value="0" v-if="filterAction.type == 0 || filterAction.type == 1"><font size="1">指定なし</font></b-radio>
              <b-radio v-model="filterAction.select" :native-value="1" v-if="filterAction.type == 1"><font size="1">未返信</font></b-radio>
              <b-radio v-model="filterAction.select" :native-value="2" v-if="filterAction.type == 0"><font size="1">未送信</font></b-radio>
              <b-radio v-model="filterAction.select" :native-value="3" v-if="filterAction.type == 0"><font size="1">未開封</font></b-radio>
              <b-radio v-model="filterAction.select" :native-value="4" v-if="filterAction.type == 0 && !filterAction.chatbots"><font size="1">開封済</font></b-radio>
              <b-radio v-model="filterAction.select" :native-value="5" v-if="filterAction.type == 0 && filterAction.chatbots"><font size="1">未リンク</font></b-radio>
              <b-radio v-model="filterAction.select" :native-value="6" v-if="filterAction.type == 0 && filterAction.chatbots"><font size="1">未回答</font></b-radio>
              <b-radio v-model="filterAction.select" :native-value="7" v-if="filterAction.type == 0 && filterAction.chatbots"><font size="1">回答済</font></b-radio>
            </div>
            <!-- 面接予定日 -->
            <div v-if="f.type == 22">
              <div class="mdi mdi-loading mdi-spin mdi-24px" v-if="seekerFilterItems == null"></div>
              <div v-else class="filter-custom-free">
                <SelectTree :contents="multipleFilterDisplayDates"  :statusKey="'__select__'" :title="'すべて選択'"></SelectTree>
              </div>
            </div>
            <!-- フラグ -->
            <select class="select" v-model="filterWord" v-if="f.type == 24">
              <option v-for="(flg, i) in flgTypes" :key="i + '-param8'" :value="i">{{flg}}</option>
            </select>
            <!-- ロボ会話履歴-->
            <v-select class="select-robotalk"
              v-if="f.type == 25"
              v-model="filterChatbot"
              :options="chatbots"
              label="name" :reduce="name => name.bot_id"
              :components="{Deselect: {render: createElement => createElement('span', '')}}"></v-select>
            <!-- カスタムカラム(自由入力, 選択肢) -->
            <div v-if="f.type == 0 && f.type_custom_culumn <= 2">
              <input class="input is-small" style="width: 95%;" placeholder="選択肢を絞り込み" v-model="multipleFilterSearchWord" />
              <div class="mdi mdi-loading mdi-spin mdi-24px" v-if="seekerFilterItems == null"></div>
              <div v-else class="filter-custom-free">
                <div>
                  <b-checkbox
                    @change.native="multipleFilterSelectedItems = $event.target.checked ? $_.union(multipleFilterSelectedItems, filteredSeekerFilterItems) : $_.difference(multipleFilterSelectedItems, filteredSeekerFilterItems)"
                    :indeterminate="$_.intersection(multipleFilterSelectedItems, filteredSeekerFilterItems).length != 0 && $_.intersection(multipleFilterSelectedItems, filteredSeekerFilterItems).length != filteredSeekerFilterItems.length"></b-checkbox>
                  すべて選択
                </div>
                <div v-for="item in filteredSeekerFilterItems" :key="item" style="margin-left: 16px;">
                  <b-checkbox
                    v-model="multipleFilterSelectedItems"
                    :native-value="item"></b-checkbox>
                    <span v-if="item==''" style="font-style: oblique;">(未入力)</span>
                    <span v-else>{{ item }}</span>
                </div>
              </div>
            </div>
            <!-- カスタムカラム(日付) -->
            <div v-if="f.type == 0 && f.type_custom_culumn == 3">
              <div class="mdi mdi-loading mdi-spin mdi-24px" v-if="seekerFilterItems == null"></div>
              <div v-else class="filter-custom-free">
                <SelectTree :contents="multipleFilterDisplayDates"  :statusKey="'__select__'" :title="'すべて選択'"></SelectTree>
              </div>
            </div>
            <div v-if="f.type != 1 && f.type!=10 && f.type != 16 && f.type != 19 && f.type !=20 && f.type != 21 && f.type != 24 && f.type != 25 && f.type != 30">
              <p><font size="1">※未入力での検索時は「未入力の応募者」が抽出されます。</font></p>
            </div>
            <div v-else-if="f.type == 19 || f.type == 20 || f.type == 21">
              <p><font size="1">※未選択での検索時は「未設定の応募者」が抽出されます。</font></p>
            </div>
            <div v-else-if="f.type == 25">
              <p><font size="1">※未選択での検索時は「ゴール未通過の応募者」が抽出されます。</font></p>
            </div>
            <div style="display: flex; justify-content: center; margin-top: 8px;">
              <button class="button is-small is-primary" style="margin-right: 8px; width: 80px;" @click="changeFilter(f, i)">適用</button>
              <button class="button is-small" style="width: 80px;" @click="changeIdxFilter=-1">閉じる</button>
            </div>
          </div>
          <!-- フィルタ解除 -->
          <span @click="deleteFilter(i)" class="mdi mdi-close" style="margin-left: 4px; cursor: pointer;"></span>
        </b-tag>
      </template>
    </div>
    <div class="recruit-box disp-scroll" :style="{'height' : filtered.length > 0 ? 'calc(100% - 158px)' : 'calc(100% - 108px)'}" v-if="filteredSeekersNum > 0 && !isSeekerLoading">
      <table ref="rec_tbl" id="rec-tbl" class="recruit-table" style="overflow: scroll; will-change: transform;">
        <tr class="header-col">
          <th id="col-th-select-box" class="fixed-col-01">
            <div style="width: 100%; display: flex; justify-content: center; align-items: center; margin-left: 8px;">
              <b-checkbox v-model="isAllCheck"></b-checkbox>
            </div>
          </th>
          <th
            id="col-th-individual-action"
            class="fixed-col-03"
            :class="{'fixed-col-03-not-archive': !archiveSwitch, 'fixed-col-03-archive': archiveSwitch}"
          >
          個別アクション
          </th>
          <template v-for="(t, i) in companyColumnSetting">
            <th
              :class="{'fixed-col-ZZ': t.is_sticky}"
              :style="[stickyHeaderStyle[t.pk], {'z-index': 10000 - i}]"
              :key="i + '-param3'"
              :id="'col-th-' + t.pk"
              v-if="!t.is_disabled"
            >
              <p style="margin-left: 20px; margin-right: 20px; overflow: auto;">{{t.name}}</p>
              <button class="filter-button" @click="idxFilter=i; filterWord = null" v-if="canFilter(t.template_type)"><span class="mdi mdi-filter"></span></button>
              <!-- フィルタリング -->
              <div @keypress.enter="addFilter(t, i)" style="position: absolute; width: auto; padding: 8px; top: 40px; background: #FEFEFE; color: #2c3e50; border: solid thin #ccc; z-index: 20001;" v-if="i==idxFilter">
                <h2 style="padding: 8px; font-weight: 600;">{{t.name}}</h2>
                <!-- ソート -->
                <div class="tabs is-centered is-toggle is-small" style="margin-botton: 8px;" v-if="t.template_type!=0 && t.template_type!=1 && t.template_type!=14 && t.template_type!=15 && t.template_type!=18 && t.template_type!=19 && t.template_type!=20 && t.template_type!=21 && t.template_type!=24 && t.template_type!=25">
                  <ul>
                    <li :class="{'is-active': sortAsc}">
                      <a @click="sortAsc=true;sortDesc=false;">昇順</a>
                    </li>
                    <li :class="{'is-active': !sortAsc && !sortDesc}">
                      <a @click="sortAsc=false;sortDesc=false;">標準</a>
                    </li>
                    <li :class="{'is-active': sortDesc}">
                      <a @click="sortAsc=false;sortDesc=true;">降順</a>
                    </li>
                  </ul>
                </div>
                <!-- フィルター -->
                <input class="input is-small" style="width: 95%;" placeholder="フィルタを入力" v-model="filterWord"
                  v-if="
                    t.template_type!=0 &&   // カスタムカラム
                    t.template_type!=1 &&   // 媒体
                    t.template_type!=6 &&   // 生年月日
                    t.template_type!=9 &&   // 性別
                    t.template_type!=10 &&  // 状況
                    t.template_type!=11 &&  // 応募日
                    t.template_type!=12 &&  // 応募回数
                    t.template_type!=16 &&  // スカウト
                    t.template_type!=19 &&  // ステージ
                    t.template_type!=20 &&  // ステータス
                    t.template_type!=21 &&  // アクション
                    t.template_type!=22 &&  // 面接予定日
                    t.template_type!=24 &&  // フラグ
                    t.template_type!=25 &&  // ロボ会話履歴
                    t.template_type!=30     // 管理ID
                    "
                />
                <!-- 管理ID -->
                <div style="display: flex; align-items: center;" v-if="t.template_type == 30">
                  <b-numberinput size="is-small" style="margin-right: 8px;" :controls="false" v-model="filterWord"/>
                </div>
                <!-- 媒体 -->
                <v-select class="select-recruit"
                  v-if="t.template_type == 1"
                  v-model="filterMedia"
                  appendToBody
                  :calculate-position="(dropdownList, component, {width, top, left}) => {
                    dropdownList.style.top = top;
                    dropdownList.style.left = left;
                    dropdownList.style.width = width;
                    dropdownList.style.fontSize = '12px';
                  }"
                  :options="filterRecruitList"
                  label="name" :reduce="rec => rec.name"
                  :components="{Deselect: {render: createElement => createElement('span', '')}}"></v-select>
                <!-- 性別 -->
                <select class="select" v-model="filterWord" v-if="t.template_type == 9">
                  <option v-for="(s, i) in sexTypes" :key="i + '-param3'" :value="i">{{s}}</option>
                </select>
                <!-- 状況 -->
                <select class="select" v-model="filterWord" v-if="t.template_type == 10">
                  <option v-for="(op, i) in options" :key="i + '-param4'" :value="op.value">{{op.text}}</option>
                </select>
                <!-- 訪問回数 -->
                <select class="select" v-model="filterWord" v-if="t.template_type == 12">
                  <option v-for="i in 5" :key="i + '-param5'" :value="i">{{i}}回</option>
                </select>
                <!-- 生年月日 -->
                <div style="display: flex; align-items: center;" v-if="t.template_type == 6">
                  <b-numberinput size="is-small" style="margin-right: 8px;" :controls="false" v-model="fromAge"/>歳から
                  <b-numberinput size="is-small" style="margin-left: 8px; margin-right: 8px;" :controls="false" v-model="toAge"/>歳まで
                </div>
                <!-- 応募日 -->
                <div v-if="t.template_type == 11">
                  <div class="mdi mdi-loading mdi-spin mdi-24px" v-if="seekerFilterItems == null"></div>
                  <div v-else class="filter-custom-free disp-scroll">
                    <SelectTree :contents="multipleFilterDisplayDates"  :statusKey="'__select__'" :title="'すべて選択'"></SelectTree>
                  </div>
                </div>
                <!-- スカウト -->
                <select class="select" v-model="filterScout" v-if="t.template_type == 16">
                  <option v-for="(sc, i) in [false, true]" :key="i + '-param6'" :value="sc">{{sc ? '送付済' : '未送付'}}</option>
                </select>
                <!-- ステージ -->
                <v-select class="select-recruit"
                  v-if="t.template_type == 19"
                  v-model="filterStage"
                  appendToBody
                  :calculate-position="(dropdownList, component, {width, top, left}) => {
                    dropdownList.style.top = top;
                    dropdownList.style.left = left;
                    dropdownList.style.width = width;
                    dropdownList.style.fontSize = '12px';
                  }"
                  :options="recruitmentFlowStages"
                  label="name"
                  :components="{Deselect: {render: createElement => createElement('span', '')}}"></v-select>
                <!-- ステータス -->
                <v-select class="select-recruit"
                  v-if="t.template_type == 20"
                  v-model="filterStatus"
                  appendToBody
                  :calculate-position="(dropdownList, component, {width, top, left}) => {
                    dropdownList.style.top = top;
                    dropdownList.style.left = left;
                    dropdownList.style.width = width;
                    dropdownList.style.fontSize = '12px';
                  }"
                  :options="recruitmentFlowStatus"
                  label="name"
                  :components="{Deselect: {render: createElement => createElement('span', '')}}"></v-select>
                <!-- アクション -->
                <v-select class="select-recruit"
                  v-if="t.template_type == 21"
                  v-model="filterAction"
                  appendToBody
                  :calculate-position="(dropdownList, component, {width, top, left}) => {
                    dropdownList.style.top = top;
                    dropdownList.style.left = left;
                    dropdownList.style.width = width;
                    dropdownList.style.fontSize = '12px';
                  }"
                  :options="recruitmentFlowActions"
                  label="name"
                  :components="{Deselect: {render: createElement => createElement('span', '')}}"></v-select>
                <!-- アクション結果 1:SMS 0:Email-->
                <div class="filter-sort block" v-if="t.template_type == 21 && filterAction">
                  <b-radio v-model="filterAction.select" :native-value="0" v-if="filterAction.type == 0 || filterAction.type == 1"><font size="1">指定なし</font></b-radio>
                  <b-radio v-model="filterAction.select" :native-value="1" v-if="filterAction.type == 1"><font size="1">未返信</font></b-radio>
                  <b-radio v-model="filterAction.select" :native-value="2" v-if="filterAction.type == 0"><font size="1">未送信</font></b-radio>
                  <b-radio v-model="filterAction.select" :native-value="3" v-if="filterAction.type == 0"><font size="1">未開封</font></b-radio>
                  <b-radio v-model="filterAction.select" :native-value="4" v-if="filterAction.type == 0 && !filterAction.chatbots"><font size="1">開封済</font></b-radio>
                  <b-radio v-model="filterAction.select" :native-value="5" v-if="filterAction.type == 0 && filterAction.chatbots"><font size="1">未リンク</font></b-radio>
                  <b-radio v-model="filterAction.select" :native-value="6" v-if="filterAction.type == 0 && filterAction.chatbots"><font size="1">未回答</font></b-radio>
                  <b-radio v-model="filterAction.select" :native-value="7" v-if="filterAction.type == 0 && filterAction.chatbots"><font size="1">回答済</font></b-radio>
                </div>
                <!-- 面接予定日 -->
                <div v-if="t.template_type == 22">
                  <div class="mdi mdi-loading mdi-spin mdi-24px" v-if="seekerFilterItems == null"></div>
                  <div v-else class="filter-custom-free disp-scroll">
                    <SelectTree :contents="multipleFilterDisplayDates"  :statusKey="'__select__'" :title="'すべて選択'"></SelectTree>
                  </div>
                </div>
                <!-- フラグ -->
                <select class="select" v-model="filterWord" v-if="t.template_type == 24">
                  <option v-for="(flg, i) in flgTypes" :key="i + '-param8'" :value="i">{{flg}}</option>
                </select>
                <!-- ロボ会話履歴-->
                <v-select class="select-robotalk"
                  v-if="t.template_type == 25"
                  v-model="filterChatbot"
                  appendToBody
                  :calculate-position="(dropdownList, component, {width, top, left}) => {
                    dropdownList.style.top = top;
                    dropdownList.style.left = left;
                    dropdownList.style.width = width;
                    dropdownList.style.fontSize = '12px';
                  }"
                  :options="chatbots"
                  label="name" :reduce="name => name.bot_id"
                  :components="{Deselect: {render: createElement => createElement('span', '')}}"></v-select>
                <!-- カスタムカラム(自由入力, 選択肢) -->
                <div v-if="t.template_type == 0 && t.type_for_custom_column <= 2">
                  <input class="input is-small" style="width: 95%;" placeholder="選択肢を絞り込み" v-model="multipleFilterSearchWord" />
                  <div class="mdi mdi-loading mdi-spin mdi-24px" v-if="seekerFilterItems == null"></div>
                  <div v-else class="filter-custom-free disp-scroll">
                    <div>
                      <b-checkbox
                        @change.native="multipleFilterSelectedItems = $event.target.checked ? $_.union(multipleFilterSelectedItems, filteredSeekerFilterItems) : $_.difference(multipleFilterSelectedItems, filteredSeekerFilterItems)"
                        :indeterminate="$_.intersection(multipleFilterSelectedItems, filteredSeekerFilterItems).length != 0 && $_.intersection(multipleFilterSelectedItems, filteredSeekerFilterItems).length != filteredSeekerFilterItems.length"></b-checkbox>
                      すべて選択
                    </div>
                    <div v-for="item in filteredSeekerFilterItems" :key="item" style="margin-left: 16px;">
                      <b-checkbox
                        v-model="multipleFilterSelectedItems"
                        :native-value="item"></b-checkbox>
                        <span v-if="item==''" style="font-style: oblique;">(未入力)</span>
                        <span v-else>{{ item }}</span>
                    </div>
                  </div>
                </div>
                <!-- カスタムカラム(日付) -->
                <div v-if="t.template_type == 0 && t.type_for_custom_column == 3">
                  <div class="mdi mdi-loading mdi-spin mdi-24px" v-if="seekerFilterItems == null"></div>
                  <div v-else class="filter-custom-free disp-scroll">
                    <SelectTree :contents="multipleFilterDisplayDates"  :statusKey="'__select__'" :title="'すべて選択'"></SelectTree>
                  </div>
                </div>
                <div v-if="t.template_type != 0 && t.template_type != 1 && t.template_type !=10 && t.template_type != 11 && t.template_type != 16 && t.template_type != 19 && t.template_type != 20 && t.template_type != 21 && t.template_type != 22 && t.template_type != 24 && t.template_type != 25 && t.template_type != 30">
                  <p><font size="1">※未入力での検索時は「未入力の応募者」が抽出されます。</font></p>
                </div>
                <div v-else-if="t.template_type == 19 || t.template_type == 20 || t.template_type == 21">
                  <p><font size="1">※未選択での検索時は「未設定の応募者」が抽出されます。</font></p>
                </div>
                <div v-else-if="t.template_type == 25">
                  <p><font size="1">※未選択での検索時は「ゴール未通過の応募者」が抽出されます。</font></p>
                </div>
                <div style="display: flex; justify-content: center; margin-top: 8px;">
                  <button class="button is-small is-primary" style="margin-right: 8px; width: 80px;" @click="addFilter(t, i)">適用</button>
                  <button class="button is-small" style="width: 80px;" @click="idxFilter=-1">閉じる</button>
                </div>
              </div>
              <div
                @mousedown="startResize($event, t.pk)"
                :style="getResizeBorder()"
                v-if="isLoadingBorder">
              </div>
            </th>
          </template>
        </tr>
        <tr
          style="max-height: 50px; min-height: 50px; height: 50px;"
          @mouseover="changeIndex = index"
          v-for="(sk, index) in filteredSeekers" :key="index + '-param7'"
        >
          <td class="fixed-col-02" style="min-width: 40px; vertical-align: middle;">
            <div style="width: 100%; display: flex; justify-content: center; align-items: center; margin-left: 8px;">
              <b-checkbox :value="getCheckBoxValue(sk)" @input="checkbox(sk, $event)"></b-checkbox>
            </div>
          </td>
          <!-- 個別アクション -->
          <td
            class="individual-action fixed-col-04"
            :class="{'fixed-col-04-not-archive': !archiveSwitch, 'fixed-col-04-archive': archiveSwitch}"
            style="overflow-y: visible; vertical-align: middle; overflow: visible;"
            :style="{'z-index': 2147483646 - index}"
          >
            <div style="display: flex; justify-content: center;">
              <div class="tooltip" @click="openEmailModal(sk)">
                <button class="button is-info is-small is-info"><span class="mdi mdi-email"></span></button>
                <div v-if="user.companySMSTEL" class="tooltip-mail">メール / SMS</div>
                <div v-else class="tooltip-mail">メール</div>
              </div>
              <div class="tooltip" @click="openMessageModal(sk)">
                <button class="button is-info is-small is-info"><span class="mdi mdi-comment"></span></button>
                <div class="tooltip-message">メッセージ</div>
              </div>
              <div class="tooltip" @click="archiveSeeker([sk], !archiveSwitch)" v-show="!blacklistSwitch">
                <button class="button is-info is-small" :class="{'is-danger': !archiveSwitch, 'is-success': archiveSwitch}">
                  <span v-show="!archiveSwitch" class="mdi mdi-archive"></span>
                  <span v-show="archiveSwitch" class="mdi mdi-backup-restore"></span>
                </button>
                <div v-show="!archiveSwitch" class="tooltip-archive">アーカイブ</div>
                <div v-show="archiveSwitch" class="tooltip-archive">応募者一覧<br>に戻す</div>
              </div>
              <div class="tooltip" @click="logicalDeleteSeeker([sk])">
                <button
                  v-show="archiveSwitch"
                  class="button is-small is-danger">
                  <span class="mdi mdi-delete"></span>
                </button>
                <div class="tooltip-archive">削除</div>
              </div>
            </div>
          </td>
          <template v-for="(col) in companyColumnSetting">
            <template v-if="!col.is_disabled">
              <!-- 管理ID -->
              <td
                :class="{'fixed-col-ZZ': col.is_sticky}"
                :style="stickyDataStyle[col.pk]"
                :id="'col-td-' + col.pk"
                style="vertical-align: middle;"
                :key="col.order_type + '-col30'"
                v-if="col.template_type == 30"
              >
                <div class="applicant-id">
                  {{ sk.applicant_id }}
                </div>
              </td>
              <!-- 媒体 -->
              <td
                :class="{'fixed-col-ZZ': col.is_sticky}"
                :style="stickyDataStyle[col.pk]"
                :id="'col-td-' + col.pk"
                style="vertical-align: middle;"
                :key="col.order_type + '-col1'"
                v-if="col.template_type == 1"
              >
                <b-tag size="is-small is-info" class="-bottom-8px" v-if="getScoutFlg(sk)">
                  {{sk.recruit_route}}
                </b-tag>
                <b-tag size="is-small is-primary">
                  <a target="_blank" rel="noopener" style="color: white;" :href="getHref(sk)">
                    {{getPath(sk)}}
                  </a>
                </b-tag>
                {{getManageCorp(sk)}}
              </td>
              <!-- 名前 -->
              <td
                :class="{'fixed-col-ZZ': col.is_sticky}"
                :style="stickyDataStyle[col.pk]"
                :id="'col-td-' + col.pk"
                style="vertical-align: middle; padding: 0;"
                :key="col.order_type + '-col2'"
                v-if="col.template_type == 2"
                @mouseover="initMousePos"
              >
                <span class="icons" v-if="sk.is_message_received">
                  <div class="tooltip" @click="confirmMessageReceivedSeeker(sk)" @mousemove.stop="setMousePos" @mouseleave.stop="initMousePos">
                    <span class="mdi mdi-alert-circle mdi-16px" style="color:purple;">新規メッセージ有</span>
                  </div>
                </span>
                <span class="icons" v-else-if="sk.is_responsed">
                  <div class="tooltip" @click="confirmResponsedSeeker(sk)" @mousemove.stop="setMousePos" @mouseleave.stop="initMousePos">
                    <span class="mdi mdi-alert-circle mdi-16px" style="color:blue;">新規ロボ回答有</span>
                  </div>
                </span>
                <span class="icons" v-else-if="sk.is_new">
                  <div class="tooltip" @click="confirmNewSeeker(sk)" @mousemove.stop="setMousePos" @mouseleave.stop="initMousePos">
                    <span class="mdi mdi-alert-circle mdi-16px" style="color:red;">新着</span>
                  </div>
                </span>
                <div style="height: 8px;" v-else></div>
                <a class="name" @click="changeModalDetailSeeker(sk, true)">{{sk.name}}</a>
              </td>
              <!-- 振り仮名 -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="vertical-align: middle; padding: 0; min-width: 200px;" :key="col.order_type + '-col3'" v-if="col.template_type == 3">
                <input class="input is-small cell-textbox" style="white-space: nowrap;" v-model="sk.name_phonetic" @change="updateSeekerProf(sk)"/>
              </td>
              <!-- Email -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="vertical-align: middle; padding: 0; min-width: 200px;" :key="col.order_type + '-col4'" v-if="col.template_type == 4">
                <input class="input is-small cell-textbox" style="white-space: nowrap;" v-model="sk.email" @change="updateSeekerProf(sk)"/>
              </td>
              <!-- TEL -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="vertical-align: middle; padding: 0; min-width: 150px;" :key="col.order_type + '-col5'" v-if="col.template_type == 5">
                <input class="input is-small cell-textbox" style="white-space: nowrap;" v-model="sk.tel" @change="updateSeekerProf(sk)"/>
              </td>
              <!-- 生年月日 -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}"
                :style="stickyDataStyle[col.pk]"
                :id="'col-td-' + col.pk"
                style="vertical-align: middle;"
                :key="col.order_type + '-col6'"
                v-if="col.template_type == 6"
                @click="
                  $refs.editdate.changeDate=new Date(sk.birth);
                  $refs.editdate.sk=sk;
                  $refs.editdate.toggle()"
              >
                <p v-if="sk.birth_type === 1"
                  style="white-space: nowrap;"
                >
                  {{
                    sk.birth
                    ? new Date(sk.birth).getFullYear() + '年'
                    : '設定なし'
                  }}
                </p>
                <p v-else
                  style="white-space: nowrap;"
                >
                  {{
                    sk.birth
                    ? new Date(sk.birth).getFullYear() + '/' + (new Date(sk.birth).getMonth() + 1) + '/' + new Date(sk.birth).getDate()
                    : '設定なし'
                  }}
                </p>
                <p v-if="sk.birth">{{getAge(new Date(sk.birth))}}歳</p>
              </td>
              <!-- 住所 -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="padding: 0; min-width: 200px;" :key="col.order_type + '-col7'" v-if="col.template_type == 7">
                <textarea class="input is-small cell-textbox" v-model="sk.address" @change="updateSeekerProf(sk)"></textarea>
              </td>
              <!-- ファイル -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="padding: 0;" :key="col.order_type + '-col8'" v-if="col.template_type == 8">
                <div style="width: 100%; height: 100%; display: block; padding: 8px;">
                  <div style="display: flex;">
                    <button
                      class="button is-small"
                      @click="changeModalDetailSeeker(sk, true)"
                      @mouseenter="showFileList(sk, $event)"
                    >
                      <span class="mdi mdi-menu -right-8px"></span>詳細 ({{sk.seeker_files.length}}件)
                    </button>
                    <b-upload v-model="addFile">
                      <a class="button is-small -left-8px" style="width: 90px; border: solid 1.5px #d6d; border-radius: 0;" @click="fileUpSk = sk">+ ファイル</a>
                    </b-upload>
                    <button @click="$refs.edit.seeker = sk;$refs.edit.isShowModal = true" class="button is-small" style="width: 90px; border: solid 1.5px #6d6; border-radius: 0; margin-left: 8px;">+ 履歴書</button>
                  </div>
                </div>
              </td>
              <!-- 性別 -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="vertical-align: middle;" :key="col.order_type + '-col10'" v-if="col.template_type == 9">
                <select class="select" v-model="sk.sex" @change="updateSeekerProf(sk)">
                  <option v-for="(s, key) in sexTypes" :value="key" :key="key + '-col11'">
                    {{ s }}
                  </option>
                </select>
              </td>
              <!-- 状況 -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="vertical-align: middle;" :key="col.order_type + '-col12'" v-if="col.template_type == 10">
                <select class="select" v-model="sk.progress_rate" @change="updateSeekerProf(sk)">
                  <option v-for="option in options" v-bind:value="option.value" :key="option.value + '-col13'">
                      {{ option.text }}
                  </option>
                </select>
              </td>
              <!-- 応募情報取得日 -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="vertical-align: middle;" :key="col.order_type + '-col14'" v-if="col.template_type == 11">
                <p style="white-space: nowrap;">{{getOnlyDate(sk.subscribe_date)}}</p>
              </td>
              <!-- 応募回数 -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="vertical-align: middle;" :key="col.order_type + '-col15'" v-if="col.template_type == 12">
                {{sk.subscribe_count}}回
              </td>
              <!-- 備考 -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" 
                  :style="stickyDataStyle[col.pk]" 
                  :id="'col-td-' + col.pk" 
                  style="padding:0; min-width: 250px;" 
                  :key="col.order_type + '-col16'" 
                  v-if="col.template_type == 13"
              >
                <div class="cell-content-wrapper">
                  <textarea 
                    class="input is-small cell-textbox" 
                    v-model="sk.message" 
                    @change="updateSeekerProf(sk)"
                    @mouseenter="showCellContent(sk.message, $event)"
                    @mouseleave="handleMouseLeave"
                  ></textarea>
                </div>
              </td>
              <!-- 学歴/職歴 -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="padding: 0; min-width: 360px; vertical-align: middle;" :key="col.order_type + '-col17'" v-if="col.template_type == 14">
                <div class="reki-col">
                  <template v-for="(ca, j) in sk.career">
                    <div style="display: flex; align-items: center; font-size: smaller; border-bottom: dotted thin #ccc; margin-bottom: 4px; margin-right: 8px; margin-left: 8px;" :key="j" v-if="sk.career.length > 0">
                      <input class="input is-small" style="background: transparent; border: none; border-radius: 0; -webkit-appearance: none; box-shadow: none; width: 48px;" v-model="ca.career_year" @change="updateCareers(sk)">年
                      <input class="input is-small" style="background: transparent; border: none; border-radius: 0; -webkit-appearance: none; box-shadow: none; width: 48px;" v-model="ca.career_month" @change="updateCareers(sk)">月
                      <input class="input is-small" style="background: transparent; border: none; border-radius: 0; -webkit-appearance: none; box-shadow: none; width: calc(100% - 96px); text-align: left;" v-model="ca.career_body" @change="updateCareers(sk)">
                    </div>
                  </template>
                  <button class="button is-small" style="border-radius: 0; margin-top: 4px; border: solid 1.5px #d6d;" @click="createCareer(sk)">+ 追加</button>
                </div>
              </td>
              <!-- 資格 -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="padding: 0; min-width: 360px; vertical-align: middle;" :key="col.order_type + '-col19'" v-if="col.template_type == 15">
                <div class="reki-col">
                  <template v-for="(qu, j) in sk.qualification">
                    <div style="display: flex; align-items: center; font-size: smaller; border-bottom: dotted thin #ccc; margin-bottom: 4px; margin-right: 8px; margin-left: 8px;" :key="j" v-if="sk.qualification.length > 0">
                      <input class="input is-small" style="background: transparent; border: none; border-radius: 0; -webkit-appearance: none; box-shadow: none;  width: 48px;" v-model="qu.qualification_year" @change="updateQualifications(sk)">年
                      <input class="input is-small" style="background: transparent; border: none; border-radius: 0; -webkit-appearance: none; box-shadow: none;  width: 48px;" v-model="qu.qualification_month" @change="updateQualifications(sk)">月
                      <input class="input is-small" style="background: transparent; border: none; border-radius: 0; -webkit-appearance: none; box-shadow: none;  width: calc(100% - 96px); text-align: left;" v-model="qu.qualification_body" @change="updateQualifications(sk)">
                    </div>
                  </template>
                  <button class="button is-small" style="border-radius: 0; margin-top: 4px; border: solid 1.5px #d6d;" @click="createQualification(sk)">+ 追加</button>
                </div>
              </td>
              <!-- スカウト -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" :key="col.order_type + '-col20'" v-if="col.template_type == 16">
                <template v-if="sk.scout_mail_flg">送付済み</template>
                <template v-else></template>
              </td>
              <!-- 連携ID -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="padding: 0;" :key="col.order_type + '-col21'" v-if="col.template_type == 17">
                <input class="input is-small cell-textbox" v-model="sk.job_offer_no" @change="updateSeekerProf(sk)"/>
              </td>
              <!-- 外部連携 -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="padding: 0; vertical-align: middle;" :key="col.order_type + '-col22'" v-if="col.template_type == 18">
                <button @click="openOtherInfo(sk)" class="button is-small" style="border: solid 1.5px #d6d; border-radius: 0;">連携情報</button>
              </td>
              <!-- 採用フロー:ステージ -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="vertical-align: middle;"
                :key="col.order_type + '-col22'"
                v-if="col.template_type == 19">
                <template v-if="sk.recruitment_flow_stage">
                  <template v-for="(stg, keyStg) in selectData">
                    <span v-if="sk.recruitment_flow_stage==stg.pk" :key="keyStg">
                      <a
                        style="padding: 2px 0; text-align: center; text-decoration: none; border-radius: 4px; font-size: 0.75rem;"
                        :style="{'background-color': bgColor(stg.color), 'color': textColor(stg.color)}"
                        class="name" @click="changeModalStage(sk, true, selectData)"
                      >{{stg.name}}</a>
                    </span>
                  </template>
                </template>
                <template v-else>
                  <a class="name" style="color:blue" @click="changeModalStage(sk, true, selectData)">設定する</a>
                </template>
              </td>
              <!-- 採用フロー:ステータス -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="vertical-align: middle;" :key="col.order_type + '-col23'" v-if="col.template_type == 20">
              <template v-if="recruitmentFlows.length > 0">
                <template v-if="sk.recruitment_flow_status">
                  <span v-for="(sts, keySts) in getRecruitmentFlowStatus(sk.recruitment_flow_stage)" v-bind:value="sts.pk" :key="keySts + '-col24'">
                    <span v-if="sk.recruitment_flow_status==sts.pk">
                    <a
                      style="padding: 2px 0; text-align: center; text-decoration: none; border-radius: 4px; font-size: 0.75rem;"
                      :style="{'background-color': bgColor(sts.color), 'color': textColor(sts.color)}"
                      class="name" @click="changeModalStatus(sk, true, getRecruitmentFlowStatus(sk.recruitment_flow_stage))"
                    >{{sts.name}}</a>
                    </span>
                  </span>
                </template>
                <template v-else-if="!sk.recruitment_flow_stage">
                    <p style="display: flex; min-width: 272px; color: gray; white-space: nowrap;">ステージを選択してください</p>
                </template>
                <template v-else>
                  <a class="name" style="color:blue" @click="changeModalStatus(sk, true, getRecruitmentFlowStatus(sk.recruitment_flow_stage))">設定する</a>
                </template>
              </template>
              </td>
              <!-- 採用フロー:アクション -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="vertical-align: middle;" :key="col.order_type + '-col25'" v-if="col.template_type == 21">
                <template v-if="recruitmentFlows.length > 0">
                  <ActionSet
                    :skProp="sk"
                    :actionProp="getRecruitmentFlowActions(sk.recruitment_flow_status)"
                    @openActionCheckModal="openActionCheckModal"
                    @openActionTableModal="openActionTableModal"
                  />
                </template>
              </td>
              <!-- カスタムカラム　-->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="width: auto; padding: 0; overflow: auto; vertical-align: middle;" :key="col.order_type + '-col26'" v-if="col.template_type == 0">
                <template v-for="c in sk.custom_column">
                  <template v-if="col.is_multiline && col.is_pulldown_flg == 0">
                    <div class="cell-content-wrapper">
                      <textarea
                        class="textarea is-small cell-textbox"
                        v-model="c.content"
                        @change="updateCustomColumnByCell(sk, c)"
                        :key="c.pk + '-col27'"
                        v-if="isLastCol(sk, col, c)"
                        @mouseenter="showCellContent(c.content, $event)"
                        @mouseleave="handleMouseLeave"
                      ></textarea>
                    </div>
                  </template>
                  <template v-else-if="col.is_pulldown_flg == 1">
                    <select
                      :key="c.pk + '-col27'"
                      class="select"
                      v-model="c.content"
                      @change="updateCustomColumnByCell(sk, c)"
                      v-if="isLastCol(sk, col, c)"
                    >
                      <option value="">選択してください</option>
                      <option
                        v-for="option in getOptionsForColumn(col.pk)"
                        :value="option.name" 
                        :key="option.id"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                  </template>
                  <template v-else-if="col.type_for_custom_column == 3">
                    <input
                      type="date"
                      class="input is-small"
                      v-model="c.content"
                      @change="updateCustomColumnByCell(sk, c, $event.target.value)"
                      :key="c.pk + '-col27'"
                      v-if="isLastCol(sk, col, c)"
                    />
                  </template>
                  <template v-else>
                    <input
                      class="input is-small cell-textbox"
                      v-model="c.content"
                      @change="updateCustomColumnByCell(sk, c)"
                      :key="c.pk + '-col27'"
                      v-if="isLastCol(sk, col, c)"/>
                  </template>
                </template>
                <button
                  class="button is-small"
                  style="border-radius: 0; margin-top: 4px; border: solid 1.5px #d6d;"
                  @click.once="createCustomColumn(sk, col)"
                  v-if="!isColInSkInfo(sk, col) && col.is_pulldown_flg == 0 && col.type_for_custom_column != 3">
                  + 作成
                </button>
                <select
                  class="select"
                  v-if="!isColInSkInfo(sk, col) && col.is_pulldown_flg == 1"
                  @change="handleSelectChange($event, sk, col)"
                >
                  <option value="" disabled selected>選択してください</option>
                  <option
                    v-for="option in getOptionsForColumn(col.pk)"
                    :value="option.name"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <template v-if="!isColInSkInfo(sk, col) && col.type_for_custom_column == 3">
                  <input
                    type="date"
                    @change="handleSelectChange($event, sk, col)"
                  />
                </template>
              </td>
              <!-- 面接予定日 -->
              <td
                :class="{'fixed-col-ZZ': col.is_sticky}"
                :style="stickyDataStyle[col.pk]"
                :id="'col-td-' + col.pk"
                style="vertical-align: middle;"
                :key="col.order_type + '-col28'"
                v-if="col.template_type == 22"
              >
                <p v-if="getInterviewDateMagicNum(sk.interview_history) === 1"
                  @click="changeModalSetDate(true, sk)"
                  style="color: blue; cursor: pointer"
                  >{{getInterviewDate(sk.interview_history)}}</p>
                <p v-else-if="getInterviewDateMagicNum(sk.interview_history) === 99" @click="changeModalCreateDate(true, sk)" style="color:blue; text-align: center; white-space: pre-wrap;text-decoration:underline; cursor: pointer">設定する</p>
                <p v-else @click="changeModalChangeDate(true, sk, sk.interview_history)" style="color:#aa0000; text-align: left; white-space: pre-wrap;text-decoration:underline; cursor: pointer">{{getInterviewDate(sk.interview_history)}}</p>
              </td>
              <!-- 録画面接 -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="vertical-align: middle;" :key="col.order_type + '-col29'" v-if="col.template_type == 23">
                <button
                  class="button is-small"
                  style="border-radius: 0; margin-top: 4px; border: solid 1.5px #d6d;"
                  @click="viewAnswer(sk)"
                >
                  回答閲覧
                </button>
              </td>
              <!-- フラグ -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="vertical-align: middle;" :key="col.order_type + '-col29'" v-if="col.template_type == 24">
                <div style="display: flex; justify-content: center; align-items: center">
                  <template v-if="duplicatedApplicants(sk).length || blacklistedApplicant(sk)">
                    <!-- 重複フラグ -->
                    <div v-if="duplicatedApplicants(sk).length"
                        style="background-color: orange; color: white; width: 40px; padding: 8px 0; text-align: center;">
                      重
                    </div>
                    <!-- ブラックリストフラグ -->
                    <div v-if="blacklistedApplicant(sk)" 
                        style="background-color: gray; color: white; width: 40px; padding: 8px 0; text-align: center;">
                      停
                    </div>
                  </template>
                </div>
              </td>
              <!-- ロボ会話履歴 -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="vertical-align: middle;" :key="col.order_type + '-col29'" v-if="col.template_type == 25">
                <div class="tooltip" v-for="(icon,idx3) in sk.robotalk_url" @mousemove.stop="setRoboTalkMousePos" @mouseleave.stop="initRoboTalkMousePos">
                  <img class="chatbot-icon-small" :src="getIconURL(icon)"/>
                  <div class="tooltip-float-wrapper" :style="robotalkTooltipStyle">
                    <div class="tooltip-mail">{{icon.bot_name}}</div>
                  </div>
                </div>
              </td>
              <!-- 応募職種 -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="vertical-align: middle; padding: 0;" :key="col.order_type + '-col31'" v-if="col.template_type == 26">
                <input class="input is-small cell-textbox" style="white-space: nowrap;" v-model="sk.apply_occupation" @change="updateSeekerProf(sk)"/>
              </td>
              <!-- 応募勤務拠点 -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="vertical-align: middle; padding: 0;" :key="col.order_type + '-col32'" v-if="col.template_type == 27">
                <input class="input is-small cell-textbox" style="white-space: nowrap;" v-model="sk.apply_location" @change="updateSeekerProf(sk)"/>
              </td>
              <!-- 応募タイトル -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="vertical-align: middle; padding: 0;" :key="col.order_type + '-col33'" v-if="col.template_type == 28">
                <a target="_blank" rel="noopener" style="color: black;text-decoration: underline;" :href="getHref(sk)">{{ sk.apply_recruit_title }}</a>
              </td>
              <!-- 媒体連携資格 -->
              <td :class="{'fixed-col-ZZ': col.is_sticky}" :style="stickyDataStyle[col.pk]" :id="'col-td-' + col.pk" style="padding: 0; min-width: 350px;" :key="col.order_type + '-col34'" v-if="col.template_type == 29">
                <textarea class="input is-small cell-textbox disp-scroll" v-model="sk.recruitment_media_qualification" @change="updateSeekerProf(sk)" />
              </td>
            </template>
          </template>
        </tr>
        <div class="tooltip-float-wrapper" :style="tooltipStyle">
          <div class="tooltip-float">確認済みにする</div>
        </div>
      </table>
    </div>
    <div class="recruit-footer" v-if="filteredSeekersNum > 0 && !isSeekerLoading">
      <b-select class="-left-8px" size="is-small" v-model="perPage" @input="seekersPages = 1">
        <option value="30" selected>30件表示</option>
        <option value="50">50件表示</option>
        <option value="100">100件表示</option>
        <option value="150">150件表示</option>
        <option value="200">200件表示</option>
      </b-select>
      <b-pagination
        style="margin: 0px; align-items: flex-start; font-size: 14px; padding-left: 16px; padding-right: 8px;"
        :total="filteredSeekersNum"
        :current.sync="seekersPages"
        :per-page="perPage">
        <b-pagination-button
          slot-scope="props"
          :page="props.page"
          tag="button">
          {{ props.page.number }}
        </b-pagination-button>
        <b-pagination-button
          slot="previous"
          slot-scope="props"
          :page="props.page"
          tag="button">
          ＜
        </b-pagination-button>
        <b-pagination-button
          slot="next"
          slot-scope="props"
          :page="props.page"
          tag="button">
            ＞
        </b-pagination-button>
      </b-pagination>
      <!-- 総件数と表示番号 -->
      <p style="padding-left: 16px;">{{getDispNum()}}</p>
    </div>
    <div style="width: 100%; height: calc(100vh - 100px); background: #FEFEFE; display: flex; justify-content: center; align-items: center;" v-else-if="isSeekerLoading">
      <div>
        <span class="mdi mdi-spin mdi-loading mdi-48px"></span>
      </div>
    </div>
    <div style="width: 100%; height: calc(100vh - 100px); background: #FEFEFE; display: flex; justify-content: center; align-items: center;" v-else>
      <div>
        <p>応募が現在ありません。</p>
        <p>ロボを活用して、応募を増やしてみましょう。</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import createUUID         from '@/functions/createUUID'
import moment             from "moment"
import ModalCreate        from '@/views/DashBoard/Manage/ModalCreate'
import ModalEdit          from '@/views/DashBoard/Manage/ModalEdit'
import ModalDelete        from '@/views/DashBoard/Manage/ModalDelete'
import ModalActionCheck   from '@/views/DashBoard/Manage/ModalActionCheck'
import ModalActionTable   from '@/views/DashBoard/Manage/ModalActionTable'
import ModalEditDate      from '@/components/ui/ModalEditDate'
import ModalBulkAction    from '@/components/organisms/modals/ModalBulkAction'
import ModalSelectEmail   from '@/components/organisms/modals/ModalSelectEmail'
import ModalViewInterview from '@/components/VideoView/organisms/ModalViewInterview'
import ModalDetailSeeker  from '@/components/Manage/ModalDetailSeeker'
import ModalStage         from '@/components/Manage/ModalStage'
import ModalStatus        from '@/components/Manage/ModalStatus'
import ModalStageStatus   from '@/components/Manage/ModalStageStatus'
import ModalSetDate       from '@/components/Manage/ModalSetDate'
import ModalChangeDate    from '@/components/Manage/ModalChangeDate'
import ModalCreateInterviewDate from '@/components/Calendar/organisms/ModalCreateInterviewDate'
import ActionSet          from '@/components/molecules/fields/ActionSet'
import controlLogMixin from '@/mixins/controlLogMixin'
import ModalMessageList   from '@/components/organisms/modals/ModalMessageList'
import FileListPopover from '@/components2/Manage/modal/FileListPopover';
import FileModal from '@/components2/Manage/modal/FileModal';
import CellContentPopover from '@/components2/Manage/modal/CellContentPopover';
import SelectTree from '@/views/DashBoard/Operation/SelectTree';


export default {
  components: {
    ModalCreate,
    ModalEdit,
    ModalDelete,
    ModalEditDate,
    ModalActionCheck,
    ModalActionTable,
    ModalBulkAction,
    ModalSelectEmail,
    ModalViewInterview,
    ModalDetailSeeker,
    ModalStage,
    ModalStatus,
    ModalStageStatus,
    ModalSetDate,
    ModalChangeDate,
    ActionSet,
    ModalMessageList,
    ModalCreateInterviewDate,
    FileListPopover,
    FileModal,
    CellContentPopover,
    SelectTree
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    bulkSeekerList: {
      type: Array
    },
    recruitList: {
      type: Array
    },
    dataForMailAction: {
      type: Object,
      required: true
    },
    notAllowSeekerInfo: {
      type: Boolean,
      required: true
    },
    currentManage: {
      type: Number
    },
    changeCurrentManage: {
      type: Function
    },
    blacklistTab: {
      type: Boolean
    },
    changeBlacklistTab: {
      type: Function
    }
  },
  computed: {
    ...mapState('chatbot', ['chatbots']),
    ...mapState('auth', ['user', 'users', 'companyColumnSetting',  'recruitmentFlows', 'recruitmentFlowStages', 'recruitmentFlowStatus', 'recruitmentFlowActions', 'emailTemplates', 'calendarSettings','calendarSettingsDisplay','manages','select_manages', 'default_manage', 'usersStatusAPI','mediaCooperationList','pulldownOptions']),
    ...mapState('directtalk', ['seekers', 'filteredSeekers', 'filteredSeekersNum', 'seekerFilterItems', 'isSeekerLoading', 'isApplyListNone', 'downloadCSV', 'isMakingCSV', 'resumeLoading', 'pdfFile', 'isOCRReading', 'ocrData', 'getSeekerType', 'isSavingCustomColumn', 'recordingInterviews','chatLogs','detailManage']),

    // プルダウンオプションを列IDごとに整理
    pulldownOptionsByColumnId() {

      if (!this.pulldownOptions || typeof this.pulldownOptions !== 'object') {
        console.warn('pulldownOptions is not defined or not an object');
        return {};
      }

      const result = {};

        Object.entries(this.pulldownOptions).forEach(([key, value]) => {
        // キーが数値（列ID）かどうかをチェック
        const columnId = parseInt(key, 10);
        if (isNaN(columnId)) {
          console.warn(`Invalid column ID: ${key}`);
          return;
        }

        if (Array.isArray(value)) {
          result[columnId] = value.map(option => ({
            id: option.id,
            name: option.name,
            order: option.order
          })).sort((a, b) => a.order - b.order); // オプションを order で並べ替え
        } else {
          console.warn(`Options for column ${columnId} is not an array:`, value);
        }
      });

      return result;
    },

    sortByStages () {
      return this.recruitmentFlows[0].stages
        .slice().sort((a, b) => {
            if(a.order < b.order) return -1;
            if(a.order > b.order) return 1;
            return 0;
        });
    },
    selectData () {
      return this.sortByStages
    },
    filterRecruitList () {
      let recruit = this.$_.cloneDeep(this.recruitList)
      // typeは実際には存在しないID
      recruit.push({type: 997, name: 'HRモンスター'})
      recruit.push({type: 998, name: 'その他'})
      // HRモンスター求人は媒体連携設定に含め、媒体IDを999とした
      // プルダウンには他の媒体と同じように表示されるので、ここで追加はしない
      // recruit.push({type: 999, name: 'HRモンスター求人'})
      return recruit
    },
    tooltipStyle () {
      if (this.mousePos) {
        return {
          'top' : (this.mousePos.y - 43)+ 'px',
          'left': (this.mousePos.x - 24) + 'px'
        }
      }
      else {
        return {
          'display': 'none'
        }
      }
    },
    robotalkTooltipStyle () {
      if (this.robotalkmousePos) {
        return {
          'top' : (this.robotalkmousePos.y - 3)+ 'px',
          'left': (this.robotalkmousePos.x - 24) + 'px'
        }
      }
      else {
        return {
          'display': 'none'
        }
      }
    },
    filteredSeekerFilterItems() {
      let list = this.seekerFilterItems.filter(item => item.includes(this.multipleFilterSearchWord) && item != "")
      if (this.multipleFilterSearchWord == "") list.unshift("") // 検索ワードが空なら必ず未入力("")を表示
      return list
    },
  },
  data () {
    return {
      mousePos: undefined,
      robotalkmousePos: undefined,
      isSaving: false,
      isOpenOtherInfomation: false,
      isModalSetDate: false,
      isModalChangeDate: false,
      isMultiple: true,
      ManageID: '',
      isModalCreateDate: false,
      tempOtherInfomation: {},
      addFile: null,
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      template: [''],
      searchWords: null,
      archiveSwitch: false,
      blacklistSwitch: false,
      changeDate: null,
      data: '',
      select: null,
      seekersPages: 1,
      orSwitch: false,
      filtered: [],
      filterWord: null,
      filterChatbot: null,
      filterMedia: 'その他',
      filterScout: false,
      filterStage: null,
      filterStatus: null,
      filterAction: null,
      fromDate: null,
      toDate: null,
      fromAge: null,
      toAge: null,
      multipleFilterSearchWord: "",// 複数選択可能なフィルターの絞り込みワード
      multipleFilterDisplayDates: {},// 複数選択可能なフィルターの表示項目
      multipleFilterSelectedItems: [],// 複数選択可能なフィルターの選択された項目
      sortAsc: false,
      sortDesc: false,
      idxFilter: -1,
      changeIdxFilter: -1,
      isAllCheck: false,
      valList: [
        'name',
        'name_phonetic',
        'email',
        'tel',
        'birth',
        'address',
        'sex',
        'progress_rate',
        'subscribe_date',
        'subscribe_count',
        'message',
        'scout_mail_flg',
        'job_offer_no',
      ],
      selectList: [
        {
          name: 'name',
          text: '名前',
        },
        {
          name: 'email',
          text: 'Email',
        },
        {
          name: 'tel',
          text: 'TEL',
        },
        {
          name: 'subscribe_date',
          text: '応募情報取得日',
        },
        {
          name: 'progress_rate',
          text: '状況',
        },
        {
          name: 'message',
          text: '備考',
        },
        {
          name: 'subscribe_count',
          text: '応募回数',
        },
        {
          name: 'dummy',
          text: 'ダミー列',
        }
      ],
      editIndex: -1,
      changeIndex : -1,
      //個別アクションのメールのカラム置き換えにも影響があるため、変更する場合は合わせて「directtalk/constants.py」も変更する必要あり
      options  : [
        { text: '未設定', value: null},
        { text: '応募', value: 0},
        { text: '面接調整中', value: 1 },
        { text: '面接', value: 2 },
        { text: '採用', value: 3 },
        { text: '不採用', value: 4 },
        { text: '保留', value: 5 },
        { text: '', value: 6},
        { text: '履歴書受付', value: 7},
        { text: 'リクオプ入力済', value: 8},
        { text: '未対応', value: 9},
        { text: '対応中', value: 10},
        { text: '退社', value: 11},
        { text: '連絡済', value: 12},
        { text: '書類選考', value: 13},
        { text: '面接済', value: 14},
        { text: '内定', value: 15},
        { text: '内定辞退', value: 16},
        { text: '応募者離脱', value: 17},
        { text: '対象外', value: 18},
        { text: '入社', value: 19},
        { text: '辞退', value: 20},
        { text: '書類選考通過', value: 21},
        { text: '面接設定済', value: 22},
        { text: '面接参加無', value: 23},
        { text: '１次面接', value: 24},
        { text: '１次面接調整中', value: 25},
        { text: '１次面接設定済', value: 26},
        { text: '１次面接合格', value: 27},
        { text: '１次面接不合格', value: 28},
        { text: '２次面接', value: 29},
        { text: '２次面接調整中', value: 30},
        { text: '２次面接設定済', value: 31},
        { text: '２次面接合格', value: 32},
        { text: '２次面接不合格', value: 33},
        { text: '最終面接', value: 34},
        { text: '最終面接調整中', value: 35},
        { text: '最終面接設定済', value: 36},
        { text: '最終面接合格', value: 37},
        { text: '最終面接不合格', value: 38},
        { text: '連絡無', value: 39},
        { text: '対応済', value: 40},
        { text: '選考終了', value: 41},
        { text: 'NG', value: 42},
        { text: '交渉中', value: 43},
        { text: 'その他', value: 44},
        { text: 'OK', value: 45},
      ],
      sexTypes  : ['', '男性', '女性', '選択しない'],
      flgTypes: ['なし', '重', '停'],  // フラグタイプの変更
      fileUpSk: null,
      isOpenModalDelete: false,
      isOpenModalBulkAction: false,
      isOpenModalSelectEmail: false,
      messageList: [],
      selectEmailSeeker: new Object(),
      perPage: 30,
      isViewDialogOpen: false,
      selectSeeker: null,
      interviewHistory: null,
      isModalDetailSeeker: false,
      isModalStage:false,
      isModalStatus: false,
      isModalStageStatus: false,
      tempSts: null,
      tempSeeker: null,
      tempSeekers: null,
      tempStg: null,
      curCol: null,
      curColPK: null,
      pageX: null,
      curColWidth: null,
      nxtColWidth: null,
      isLoadingBorder: false,
      ops: {
        theme: 'snow',
        placeholder: '内容を入力...',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'color': [] }, { 'background': [] }]]
        }
      },
      datetime: null,
      startHour: 0,
      startMinute: 0,
      endHour: 0,
      endMinute: 0,
      sendLoadding: false,
      sendEmailTemplate: null,
      isOpenModalMessage: false,
      createDateinfo: null,
      stickyHeaderStyle: {},
      stickyDataStyle: {},
      // 応募者重複表示フラグ
      isDuplicateSeekerFlag: true,
      // ロボ会話履歴取得フラグ (応募者一覧を取得する場合はデフォルトtrue)
      isGetRoboTalk: true,
      showingFileList: false,        // ファイルリストの表示状態
      currentSeekerFiles: [],        // 現在表示中のファイルリスト
      selectedFileModal: null,       // 選択されたファイルモーダル
      isFileModalOpen: false,        // ファイルモーダルの開閉状態
      popoverStyle: {                // ポップオーバーのスタイル
        position: 'absolute',
        top: '0px',
        left: '0px',
        zIndex: 1000
      },
      hideTimeout: null,             // ポップオーバー非表示用タイマー
      showingCellContent: false,        // セルのコンテントの表示状態
      currentCellContent: '',
      hideCellTimeout: null,
      cellPopoverStyle: {                // ポップオーバーのスタイル
        position: 'absolute',
        top: '0px',
        left: '0px',
        zIndex: 1000
      },
      isPopoverHovered: false,  // ポップオーバーのホバー状態を追跡
    }
  },
  async mounted () {
    try {
      if (this.user.companyID === '1dad12e572955a7fc7fbb820a0b30a79') {
        // 介護NEXT様用
        this.options = [
          { text: '未対応', value: 9},
          { text: 'ヒアリング中', value: 10},
          { text: '連絡済み：面接日程調整中', value: 11},
          { text: '面接設定完了', value: 12},
          { text: '面接後保留', value: 13},
          { text: '採用予定', value: 14},
          { text: '採用', value: 15},
          { text: '連絡つかず不採用', value: 16},
          { text: '面接前：不採用', value: 17},
          { text: '面接前：辞退', value: 18},
          { text: '面接後：不採用', value: 19},
          { text: '面接後：辞退', value: 20},
          { text: 'FC', value: 21},
          { text: '応募', value: 0},
          { text: '面接調整中', value: 1 },
          { text: '面接', value: 2 },
          { text: '採用', value: 3 },
          { text: '不採用', value: 4 },
          { text: '保留', value: 5 },
          { text: '', value: 6},
          { text: '履歴書受付', value: 7},
          { text: 'リクオプ入力済', value: 8},
        ]
      } else if (this.user.companyID === '812a0d58878b5d5f3897dda41b4332d7') {
        // エスケアメイト様用
        this.options = [
          { text: '応募', value: 0},
          { text: '面接調整中', value: 1 },
          { text: '面接', value: 2 },
          { text: '採用', value: 3 },
          { text: '不採用', value: 4 },
          { text: '保留', value: 5 },
          { text: '', value: 6},
          { text: '履歴書受付', value: 7},
          { text: 'リクオプ入力済', value: 8},
          { text: '離脱', value: 9},
          { text: '辞退', value: 10},
          { text: '受付不可', value: 11},
        ]
      }
      this.isLoadingBorder = false
      this.$nextTick(()=>{this.updateStickyStyle()})

      if(this.$route.query.sk) {
        const uh = this.user.userHash.replace(/-/g,'')
        const res = await this.$store.dispatch(
          'directtalk/getSeekerOne',
          {
            "id": this.$route.query.sk,
            "uid": uh,
            "isDuplicateSeekerFlag": this.isDuplicateSeekerFlag,
            "isGetRoboTalk": this.isGetRoboTalk
          }
        )
        if(res.data.error==1) {
          alert(res.data.message)
        } else {
          this.changeModalDetailSeeker(res.data, true)
        }
      }
      // カスタムカラムの設定を取得（最後に移動）
      await this.getCompanyColumnSetting();
      if (this.companyColumnSetting && Array.isArray(this.companyColumnSetting)) {
        const pulldownColumns = this.companyColumnSetting.filter(col => 
          col.is_pulldown_flg === 1 || col.is_pulldown_flg === '1' || col.is_pulldown_flg === true
        );
        for (const col of pulldownColumns) {
          if (col.pk !== undefined) {
            await this.fetchCompanyPulldownColumns({ columnId: col.pk });
          }
        }
      }
    } catch(error) {
      console.error('マウント処理中にエラーが発生しました:', error);
      this.openAlert('データの読み込み中にエラーが発生しました');
    }
  },
  updated () {
    this.$nextTick(()=>{this.updateStickyStyle()})
  },
  watch: {
    seekersPages () {
      this.pageUpdate()
    },
    perPage () {
      this.pageUpdate()
    },
    orSwitch () {
      this.seekersPages = 1
      this.pageUpdate()
    },
    archiveSwitch () {
      this.pageUpdate()
    },
    blacklistSwitch () {
      this.pageUpdate()
    },
    idxFilter () {
      if (this.idxFilter === -1) {
        // 閉じたとき
        this.multipleFilterSelectedItems = []
        this.multipleFilterSearchWord = ""
        this.multipleFilterDisplayDates = {}
        return
      }
      
      // 開いたとき
      if (this.companyColumnSetting[this.idxFilter].template_type == 0
      && this.companyColumnSetting[this.idxFilter].type_for_custom_column == 1) {
        // カスタムカラム(自由入力)
        const existing = this.filtered.find(item => item.id == this.companyColumnSetting[this.idxFilter].pk)
        if (existing) this.multipleFilterSelectedItems = existing.multipleData
        else this.multipleFilterSelectedItems = []

        const conditions = {
          type: this.companyColumnSetting[this.idxFilter].template_type,
          id: this.companyColumnSetting[this.idxFilter].pk,
          manageid: this.currentManage,
          is_archive: this.archiveSwitch,
          is_blacklist: this.blacklistSwitch,
        }
        this.$store.dispatch('directtalk/getSeekerFilterItems', conditions)
      }
      else if (this.companyColumnSetting[this.idxFilter].template_type == 0
      && this.companyColumnSetting[this.idxFilter].type_for_custom_column == 2) {
        // カスタムカラム(選択肢)
        const existing = this.filtered.find(item => item.id == this.companyColumnSetting[this.idxFilter].pk)
        if (existing) this.multipleFilterSelectedItems = existing.multipleData
        else this.multipleFilterSelectedItems = []

        const data = this.pulldownOptions[this.companyColumnSetting[this.idxFilter].pk]
          .sort((a, b) => a.order - b.order)
          .map(item => item.name)
        this.$store.commit('directtalk/setSeekerFilterItems', data)
      }
      else if (this.companyColumnSetting[this.idxFilter].template_type == 0
      && this.companyColumnSetting[this.idxFilter].type_for_custom_column == 3) {
        // カスタムカラム(日付)
        const existing = this.filtered.find(item => item.id == this.companyColumnSetting[this.idxFilter].pk)
        if (existing) this.multipleFilterSelectedItems = existing.multipleData
        else this.multipleFilterSelectedItems = []

        const conditions = {
          type: this.companyColumnSetting[this.idxFilter].template_type,
          id: this.companyColumnSetting[this.idxFilter].pk,
          manageid: this.currentManage,
          is_archive: this.archiveSwitch,
          is_blacklist: this.blacklistSwitch,
        }
        this.$store.dispatch('directtalk/getSeekerFilterItems', conditions)
          .then(() => {
            this.updateMultipleFilterDisplayDates()
          })
      }
      else if (this.companyColumnSetting[this.idxFilter].template_type == 11) {
        // 応募日
        const existing = this.filtered.find(item => item.id == this.companyColumnSetting[this.idxFilter].pk)
        if (existing) this.multipleFilterSelectedItems = existing.multipleData
        else this.multipleFilterSelectedItems = []

        const conditions = {
          type: this.companyColumnSetting[this.idxFilter].template_type,
          id: this.companyColumnSetting[this.idxFilter].pk,
          manageid: this.currentManage,
          is_archive: this.archiveSwitch,
          is_blacklist: this.blacklistSwitch,
        }
        this.$store.dispatch('directtalk/getSeekerFilterItems', conditions)
          .then(() => {
            this.updateMultipleFilterDisplayDates()
          })
      }
      else if (this.companyColumnSetting[this.idxFilter].template_type == 22) {
        // 面接予定日
        const existing = this.filtered.find(item => item.id == this.companyColumnSetting[this.idxFilter].pk)
        if (existing) this.multipleFilterSelectedItems = existing.multipleData
        else this.multipleFilterSelectedItems = []

        const conditions = {
          type: this.companyColumnSetting[this.idxFilter].template_type,
          id: this.companyColumnSetting[this.idxFilter].pk,
          manageid: this.currentManage,
          is_archive: this.archiveSwitch,
          is_blacklist: this.blacklistSwitch,
        }
        this.$store.dispatch('directtalk/getSeekerFilterItems', conditions)
          .then(() => {
            this.updateMultipleFilterDisplayDates()
          })
      }
      
    },
    changeIdxFilter () {
      if (this.changeIdxFilter === -1) {
        // 閉じたとき
        this.multipleFilterSelectedItems = []
        this.multipleFilterSearchWord = ""
        this.multipleFilterDisplayDates = {}
        return
      }
      
      // 開いたとき
      if (this.filtered[this.changeIdxFilter].type == 0
      && this.filtered[this.changeIdxFilter].type_custom_culumn == 1) {
        // カスタムカラム(自由入力)
        this.multipleFilterSelectedItems = this.filtered[this.changeIdxFilter].multipleData

        const conditions = {
          type: this.filtered[this.changeIdxFilter].type,
          id: this.filtered[this.changeIdxFilter].id,
          manageid: this.currentManage,
          is_archive: this.archiveSwitch,
          is_blacklist: this.blacklistSwitch,
        }
        this.$store.dispatch('directtalk/getSeekerFilterItems', conditions)
      }
      else if (this.filtered[this.changeIdxFilter].type == 0
      && this.filtered[this.changeIdxFilter].type_custom_culumn == 2) {
        // カスタムカラム(選択肢)
        this.multipleFilterSelectedItems = this.filtered[this.changeIdxFilter].multipleData

        const data = this.pulldownOptions[this.filtered[this.changeIdxFilter].id]
          .sort((a, b) => a.order - b.order)
          .map(item => item.name)
        this.$store.commit('directtalk/setSeekerFilterItems', data)
      }
      else if (this.filtered[this.changeIdxFilter].type == 0
      && this.filtered[this.changeIdxFilter].type_custom_culumn == 3) {
        // カスタムカラム(日付)
        this.multipleFilterSelectedItems = this.filtered[this.changeIdxFilter].multipleData

        const conditions = {
          type: this.filtered[this.changeIdxFilter].type,
          id: this.filtered[this.changeIdxFilter].id,
          manageid: this.currentManage,
          is_archive: this.archiveSwitch,
          is_blacklist: this.blacklistSwitch,
        }
        this.$store.dispatch('directtalk/getSeekerFilterItems', conditions)
          .then(() => {
            this.updateMultipleFilterDisplayDates()
          })
      }
      else if (this.filtered[this.changeIdxFilter].type == 11) {
        // 応募日
        this.multipleFilterSelectedItems = this.filtered[this.changeIdxFilter].multipleData

        const conditions = {
          type: this.filtered[this.changeIdxFilter].type,
          id: this.filtered[this.changeIdxFilter].id,
          manageid: this.currentManage,
          is_archive: this.archiveSwitch,
          is_blacklist: this.blacklistSwitch,
        }
        this.$store.dispatch('directtalk/getSeekerFilterItems', conditions)
          .then(() => {
            this.updateMultipleFilterDisplayDates()
          })
      }
      else if (this.filtered[this.changeIdxFilter].type == 22) {
        // 面接予定日
        this.multipleFilterSelectedItems = this.filtered[this.changeIdxFilter].multipleData

        const conditions = {
          type: this.filtered[this.changeIdxFilter].type,
          id: this.filtered[this.changeIdxFilter].id,
          manageid: this.currentManage,
          is_archive: this.archiveSwitch,
          is_blacklist: this.blacklistSwitch,
        }
        this.$store.dispatch('directtalk/getSeekerFilterItems', conditions)
          .then(() => {
            this.updateMultipleFilterDisplayDates()
          })
      }

    },
    multipleFilterDisplayDates: {
      handler: function() {
        
        // 現在の選択状態を保持
        this.multipleFilterSelectedItems = this.multipleFilterSelectedItems.filter(item => item != "")
        if ('(未入力)' in this.multipleFilterDisplayDates && this.multipleFilterDisplayDates['(未入力)'].__select__) {
          this.multipleFilterSelectedItems.push("")
        }
        this.multipleFilterSelectedItems = this.multipleFilterSelectedItems.filter(item => item != "Provisional")
        if ('(確定前)' in this.multipleFilterDisplayDates && this.multipleFilterDisplayDates['(確定前)'].__select__) {
          this.multipleFilterSelectedItems.push("Provisional")
        }
        const years = Object.keys(this.multipleFilterDisplayDates).filter(item => item!="__select__")
        for (let year of years) {
          const months = Object.keys(this.multipleFilterDisplayDates[year]).filter(item => item!="__select__")
          for (let month of months) {
            const days = Object.keys(this.multipleFilterDisplayDates[year][month]).filter(item => item!="__select__")
            for (let day of days) {
              const selected = this.multipleFilterDisplayDates[year][month][day].__select__
              const year_num = ('0000' + year.replace('年', '')).slice(-4)
              const month_num = ('00' + month.replace('月', '')).slice(-2)
              const day_num = ('00' + day.replace('日', '')).slice(-2)
              const date = year_num + "-" + month_num + "-" + day_num
              this.multipleFilterSelectedItems = this.multipleFilterSelectedItems.filter(item => item != date)
              if (selected) {
                this.multipleFilterSelectedItems.push(date)
              }
            }
          }
        }
        
      },
      deep: true
    },
    addFile () {
      let reader = new FileReader()
      reader.onload = (e) => {
        let createFiles = new FormData()
        createFiles.append('file', this.addFile, createUUID() + this.addFile.name)
        createFiles.append('name', this.addFile.name)
        createFiles.append('seeker', this.fileUpSk.id)
        this.$store.dispatch('directtalk/createSeekerFiles', createFiles)
        this.fileUpSk = null
      }
      reader.readAsDataURL(this.addFile)
    },
    fileLeft () {
      let reader = new FileReader()
      reader.onload = (e) => {
        this.ocrResumeRows.push({
          filename: this.fileLeft.name,
          data: e.target.result.replace(/^.*,/, '')
        })
      }
      reader.readAsDataURL(this.fileLeft)
    },
    fileRight () {
      let reader = new FileReader()
      reader.onload = (e) => {
        this.ocrResumeRows.push({
          filename: this.fileRight.name,
          data: e.target.result.replace(/^.*,/, '')
        })
      }
      reader.readAsDataURL(this.fileRight)
    },
    isSeekerLoading () {
      if (!this.isSeekerLoading) {
        setTimeout(() => {this.isLoadingBorder = true}, 500)
      }
    },
    isAllCheck () {
      if (this.isAllCheck) {
        this.$emit('checkbox-all', {skList: this.filteredSeekers, isCheck: true})
      } else {
        this.$emit('checkbox-all', {skList: this.filteredSeekers, isCheck: false})
      }
    },
    // 応募者重複フラグ表示ON/OFF
    isDuplicateSeekerFlag () {
      if (this.isSeekerLoading === false) {
        this.pageUpdate()
      }
    },
  },

  methods: {
    ...mapActions('auth', ['fetchCompanyPulldownColumns', 'getCompanyColumnSetting']),

    // セレクトボックスの変更を処理
    handleSelectChange(event, sk, col) {
      const selectedValue = event.target.value;
      if (selectedValue) {
        const createCustom = {
          name: col.name,
          type: 1, // セレクトボックスの場合は1を使用
          content: selectedValue,
          select_list: '',
          column: col.pk,
          id: sk.id
        };
        this.$store.dispatch('directtalk/createSeekerCustomColumns', createCustom);
      }
    },

    // 特定の列のオプションを取得
    getOptionsForColumn(columnId) {
      const options = this.pulldownOptionsByColumnId[columnId] || [];
      if (options.length === 0) {
        console.warn(`No options found for column ${columnId}`);
      }
      return options;
    },

    setMousePos(event) {
      this.mousePos = {
        x: event.clientX - this.$refs.rec_tbl.getBoundingClientRect().left,
        y: event.clientY - this.$refs.rec_tbl.getBoundingClientRect().top
      }
    },
    initMousePos(event) {
      this.mousePos = undefined
    },
    setRoboTalkMousePos(event) {
      this.robotalkmousePos = {
        x: event.clientX - this.$refs.rec_tbl.getBoundingClientRect().left,
        y: event.clientY - this.$refs.rec_tbl.getBoundingClientRect().top
      }
    },
    initRoboTalkMousePos(event) {
      this.robotalkmousePos = undefined
    },
    formatCreatedAt(date) {
      if (date) {
        return moment(date).format('YYYY/MM/DD')
      } else {
        return '応募日情報なし'
      }
    },
    changeEmailTemplate (templateIndex) {
      this.$set(this.sendEmailTemplate, 'name', this.emailTemplates[templateIndex].name)
      this.$set(this.sendEmailTemplate, 'from_email', this.emailTemplates[templateIndex].from_email)
      this.$set(this.sendEmailTemplate, 'cc_email', this.emailTemplates[templateIndex].cc_email)
      this.$set(this.sendEmailTemplate, 'title', this.emailTemplates[templateIndex].title)
      this.$set(this.sendEmailTemplate, 'template', this.emailTemplates[templateIndex].template)
      this.$set(this.sendEmailTemplate, 'robo', this.emailTemplates[templateIndex].robo)
      this.$set(this.sendEmailTemplate, 'video_user', this.emailTemplates[templateIndex].video_user)
      this.$set(this.sendEmailTemplate, 'record', this.emailTemplates[templateIndex].record)
      alert('テンプレートを変更いたしました。')
    },
    sendEmailToSeeker (meetingDate) {
      if (this.inputConfirmationTo()) return
      this.sendLoadding = true
      if (confirm('メールをお送りします。内容にお間違いはございませんか？')) {
        if (meetingDate) this.sendEmailTemplate.meeting_date = meetingDate
        this.$store.dispatch('directtalk/sendEmailToSeeker', this.sendEmailTemplate)
          .then((d) => {
            if (d.data.error_result_list.length > 0) {
              // エラーがある場合
              let errer_list = []
              for (const error of d.data.error_result_list) {
                errer_list.push('・' + error.seeker_email + ' (' + error.seeker_name + ')：[' + error.status + ']')
              }
              alert('以下のエラーが発生しました。\n\n' + errer_list.join('\n'))
            } else {
              alert('送付完了いたしました。モーダルウィンドウを閉じます。')
            }
            this.sendLoadding = false
            this.changeModalSetDate(false, null)
            this.changeModalChangeDate(false, null, null)
            this.changeModalCreateDate(false, null)
          })
          .catch(() => {
            alert('メール送付中にエラーが発生いたしました。宛先、CC等が正しいかご確認のほど、よろしくお願いいたします。')
            this.sendLoadding = false
          })
      } else {
        alert('キャンセルされました。')
        this.sendLoadding = false
      }
    },
    inputConfirmationTo () {
      if (!this.bulk && !this.sendEmailTemplate.to_email) {
        alert('宛先（TO）が未入力です。')
        return true
      }
      if (this.bulk && !this.bulkSeekerList.length) {
        alert('宛先（TO）が未選択です。')
        return true
      }
      return false
    },
    createCompanyEmailTemplate (data) {
      let createTemplate = {
        name       : 'no title',
        from_email : '',
        to_email   : '',
        cc_email   : '',
        title      : '',
        template   : '',
        company    : this.user.companyPK
      }
      this.$store.dispatch('auth/createCompanyEmailTemplate', createTemplate)
      alert('新規作成をしました。メールテンプレートメニューからお選びください。')
    },
    updateCompanyEmailTemplate (data) {
      let updateTemplate = data
      this.$store.dispatch('auth/updateCompanyEmailTemplate', updateTemplate)
      alert('保存しました。')
    },
    deleteCompanyEmailTemplate (id) {
      this.$store.dispatch('auth/deleteCompanyEmailTemplate', id)
      alert('削除しました。')
    },
    createCompanySMSTemplate (data) {
      let createTemplate = {
        name       : 'no title',
        from_email : this.user.companySMSTEL,
        to_email   : '',
        template   : '',
        company    : this.user.companyPK,
        is_SMS      : true
      }
      this.$store.dispatch('auth/createCompanySMSTemplate', createTemplate)
      alert('新規作成をしました。メールテンプレートメニューからお選びください。')
    },
    updateCompanySMSTemplate (data) {
      let updateTemplate = data
      this.$store.dispatch('auth/updateCompanySMSTemplate', updateTemplate)
      alert('保存しました。')
    },
    deleteCompanySMSTemplate (id) {
      this.$store.dispatch('auth/deleteCompanySMSTemplate', id)
      alert('削除しました。')
    },
    copyLink (cb) {
      if (!cb) {
        alert('ロボを選択してください。')
        return
      }
      this.$nextTick(() => {
        let codeToCopy = document.querySelector('#copy-code')
        codeToCopy.setAttribute('type', 'text')
        codeToCopy.select()
        document.execCommand('copy')
        this.$buefy.snackbar.open({
          message: 'ロボ表示URLをコピーしました！',
          type: 'is-success',
          position: 'is-top',
          actionText: 'OK',
          indefinite: true
        })
        codeToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      })
    },
    tempSaveEmail(){
      localStorage.setItem('sendEmailTemplate'+'['+this.sendEmailTemplate.seeker+']',JSON.stringify(this.sendEmailTemplate));
      alert('一時保存いたしました。')
    },
    helpMessage (msg) {
      this.$buefy.dialog.alert({
        message: msg,
        confirmText: '閉じる'
      })
    },
    openEmailMenu () {
      this.sendEmailTemplate = this.$_.cloneDeep(this.emailTemplates[0])
      this.sendEmailTemplate.seeker = this.selectSeeker.id
      this.sendEmailTemplate.to_email = this.selectSeeker.email
      this.sendEmailTemplate.seeker_name = this.selectSeeker.name
    },
    closeEditPage () {
      this.changeModalCreateDate(false, null)
    },
    deleteRecruitFlowAction (id) {
      for (const seeker of this.filteredSeekers) {
        for (const history of seeker.recruitment_flow_action_history) {
          if (history.id === id) {
            const index = seeker.recruitment_flow_action_history.indexOf(history)
            if (index > -1) {
              seeker.recruitment_flow_action_history.splice(index, 1);
            }
          }
        }
      }
    },
    changeArchiveSwitch(flg) {
      this.changeCurrentManage(null)
      this.archiveSwitch = flg
      this.blacklistSwitch = false
      this.changeBlacklistTab(false)
      this.emptyBulkSeekerList()
      this.seekersPages = 1
    },
    changeBlacklistSwitch(flg) {
      this.changeCurrentManage(null)
      this.archiveSwitch = false
      this.blacklistSwitch = flg
      this.changeBlacklistTab(true)
      this.emptyBulkSeekerList()
      this.seekersPages = 1
    },
    async changeManageid(num) {
      await this.changeCurrentManage(num)
      this.archiveSwitch = false
      this.blacklistSwitch = false
      this.changeBlacklistTab(false)
      this.seekersPages = 1
      this.pageUpdate()
    },
    emptyBulkSeekerList() {
      this.isAllCheck = false
      this.$emit('checkbox-all', {skList: [], isCheck: false})
    },
    pageUpdate() {
      const getSeekerConditions = {
        is_archive: this.archiveSwitch,
        is_blacklist: this.blacklistSwitch,
        filter_type: this.orSwitch,
        filter: this.filtered,
        page: Number(this.seekersPages),
        perPage: Number(this.perPage),
        manageid: this.currentManage,
        is_duplicate_seeker_flag: this.isDuplicateSeekerFlag,
        is_get_robo_talk: this.isGetRoboTalk
      }
      const authUser = this.users.filter(i=>i.email === this.user.email)
      this.$store.dispatch('directtalk/getSubscribedSeekers', {conditions: getSeekerConditions, authUser: authUser, isAgent: this.user.isAgent})
    },
    addFilter (t, i) {
      // selectが指定されないパターンのカバー
      if (this.filterAction && !this.filterAction.select){
        this.filterAction.select = 0
      }

      let skip = false
      // 複数選択可能なフィルターは既存の設定を上書き
      if (t.template_type == 0 || t.template_type == 11 || t.template_type == 22) {
        this.filtered = this.filtered.filter(item => item.id != t.pk)
        // 選択されていなければフィルター削除
        if (this.multipleFilterSelectedItems.length == 0) skip = true
      }

      if (!skip) {
        let toDateTime = this.toDate
        if (toDateTime) {
          toDateTime.setHours(23)
          toDateTime.setMinutes(59)
          toDateTime.setSeconds(59)
        }
        this.filtered.push({
          index: i,
          id: t.pk,
          name: t.name,
          data: this.filterWord,
          multipleData: this.multipleFilterSelectedItems,
          media: this.filterMedia,
          scout: this.filterScout,
          type: t.template_type,
          type_custom_culumn: t.type_for_custom_column,
          order: t.order_type,
          fromDate: this.fromDate,
          toDate: toDateTime,
          fromAge: this.fromAge,
          toAge: this.toAge,
          sortAsc: this.sortAsc,
          sortDesc: this.sortDesc,
          chatbot: this.filterChatbot,
          stage: this.filterStage,
          status: this.filterStatus,
          action: this.filterAction,
        })
      }
      this.filterMedia = 'その他'
      this.filterScout = false
      this.filterWord = null
      this.fromDate = null
      this.filterChatbot = null
      this.filterStage = null
      this.filterStatus = null
      this.filterAction = null
      this.toDate = null
      this.fromAge = null
      this.toAge = null
      this.sortAsc = false
      this.sortDesc = false
      this.multipleFilterSearchWord = ""
      this.multipleFilterSelectedItems = []
      this.idxFilter = -1
      this.seekersPages = 1

      this.pageUpdate()
    },
    changeFilter(f,i){
      // selectが指定されないパターンのカバー
      if (this.filterAction && !this.filterAction.select){
        this.filterAction.select = 0
      }

      let skip = false
      // 複数選択可能なフィルターで選択されていなければフィルター削除
      if (f.type == 0 || f.type == 11 || f.type == 22) {
        if (this.multipleFilterSelectedItems.length == 0) {
          this.filtered = this.filtered.filter(item => item.id != f.id)
          skip = true
        }
      }

      if (!skip) {
        let toDateTime = this.toDate
        if (toDateTime) {
          toDateTime.setHours(23)
          toDateTime.setMinutes(59)
          toDateTime.setSeconds(59)
        }
        if(f.type == this.filtered[i].type){
          this.filtered[i].data = this.filterWord
          this.filtered[i].multipleData = this.multipleFilterSelectedItems
          this.filtered[i].media = this.filterMedia
          this.filtered[i].scout = this.filterScout
          this.filtered[i].fromDate = this.fromDate
          this.filtered[i].toDate = toDateTime
          this.filtered[i].fromAge = this.fromAge
          this.filtered[i].toAge = this.toAge
          this.filtered[i].sortAsc = this.sortAsc
          this.filtered[i].sortDesc = this.sortDesc
          this.filtered[i].chatbot = this.filterChatbot
          this.filtered[i].stage = this.filterStage
          this.filtered[i].status = this.filterStatus
          this.filtered[i].action = this.filterAction
        }
      }
      this.filterMedia = 'その他'
      this.filterScout = false
      this.filterWord = null
      this.fromDate = null
      this.filterChatbot = null
      this.filterStage = null
      this.filterStatus = null
      this.filterAction = null
      this.toDate = null
      this.fromAge = null
      this.toAge = null
      this.sortAsc = false
      this.sortDesc = false
      this.multipleFilterSearchWord = ""
      this.multipleFilterSelectedItems = []
      this.changeIdxFilter = -1
      this.seekersPages = 1

      this.pageUpdate()
    },
    deleteFilter (i) {
      this.filtered.splice(i, 1)
      this.seekersPages = 1
      this.pageUpdate()
    },
    getRecruitmentFlowStatus (stg) {
      if (!stg || this.recruitmentFlows.length === 0) return null
      for (let re of this.recruitmentFlows[0].stages) {
        if (re.pk === stg) return re.status
      }
      return null
    },
    getRecruitmentFlowActions (sts) {
      if (!sts || this.recruitmentFlows.length === 0) return null
      for (let i in this.recruitmentFlows[0].stages) {
        for (let re of this.recruitmentFlows[0].stages[i].status) {
          if (re.pk === sts) return re.actions
        }
      }
      return null
    },
    getAge (date) {
      const y2 = date.getFullYear().toString().padStart(4, '0')
      const m2 = (date.getMonth() + 1).toString().padStart(2, '0')
      const d2 = date.getDate().toString().padStart(2, '0')
      const today = new Date()
      const y1 = today.getFullYear().toString().padStart(4, '0')
      const m1 = (today.getMonth() + 1).toString().padStart(2, '0')
      const d1 = today.getDate().toString().padStart(2, '0')
      return Math.floor((Number(y1 + m1 + d1) - Number(y2 + m2 + d2)) / 10000)
    },
    saveDate (data) {
      let upsk = data.sk
      upsk.birth = data.date
      this.$store.dispatch('directtalk/updateSeeker', upsk)
    },
    openOtherInfo (sk) {
      if (!sk.other_infomation[0]) {
        alert('外部連携情報はありません。')
        return
      }
      this.isOpenOtherInfomation = true
      this.tempOtherInfomation = sk.other_infomation
    },
    isCustomColumn (id, columnList) {
      for (let c of columnList) {
        if (c.column == id) return true
      }
      return false
    },
    updateMultipleFilterDisplayDates() {
      // SelectTree用データ
      this.$set(this, 'multipleFilterDisplayDates', {__select__: undefined})
      let temp = {__select__: undefined}
      temp['(未入力)'] = {__select__: this.multipleFilterSelectedItems.includes("")}
      if (this.seekerFilterItems.includes("Provisional")) temp['(確定前)'] = {__select__: this.multipleFilterSelectedItems.includes("Provisional")}
      for (let date of this.seekerFilterItems) {
        if (date == "") continue
        if (date == "Provisional") continue
        const [year, month, day] = date.split('-')
        year = Number(year) + '年'
        month = Number(month) + '月'
        day = Number(day) + '日'
        temp[year] = (temp[year] || {__select__: undefined})
        temp[year][month] = (temp[year][month] || {__select__: undefined})
        temp[year][month][day] = (temp[year][month][day] || {__select__: this.multipleFilterSelectedItems.includes(date)})
      }
      const _years = Object.keys(temp).filter(year => year != "__select__")
      for (let year of _years) {
        const _months = Object.keys(temp[year]).filter(month => month != "__select__")
        if (_months.length == 0) continue
        for (let month of _months) {
          const _days = Object.keys(temp[year][month]).filter(day => day != "__select__")
          if (_days.every(day => temp[year][month][day].__select__ == true)) {
            temp[year][month].__select__ = true
          } else if (_days.every(day => temp[year][month][day].__select__ == false)) {
            temp[year][month].__select__ = false
          }
        }
        if (_months.every(month => temp[year][month].__select__ == true)) {
          temp[year].__select__ = true
        } else if (_months.every(month => temp[year][month].__select__ == false)) {
          temp[year].__select__ = false
        }
      }
      if (_years.every(year => temp[year].__select__ == true)) {
        temp.__select__ = true
      } else if (_years.every(year => temp[year].__select__ == false)) {
        temp.__select__ = false
      }
      this.multipleFilterDisplayDates = temp
    },
    // 未使用のためコメントアウト
    // async save () {
    //   this.sendControlLog('応募者一覧保存', '応募者管理画面にて「保存」ボタンを押した。')
    //   this.isSaving = true
    //   await new Promise(resolve => setTimeout(resolve, 2000)) // 2秒待つ
    //   let seekers = []
    //   let careers = []
    //   let qualifications = []
    //   let columns = []
    //   for (const sk of this.filteredSeekers) {
    //     seekers.push(sk)
    //     if (sk.career) {
    //       for (let ca of sk.career) careers.push(ca)
    //     }
    //     if (sk.qualification) {
    //       for (let qu of sk.qualification) qualifications.push(qu)
    //     }
    //     if (sk.custom_column) {
    //       for (let cu of sk.custom_column) {
    //         let updateColumn = {
    //           pk: cu.pk,
    //           name: cu.name,
    //           type: 0,
    //           content: cu.content,
    //           select_list: '',
    //           column: cu.column,
    //           id: sk.id
    //         }
    //         columns.push(updateColumn)
    //       }
    //     }
    //   }
    //   let p_seeker = this.$store.dispatch('directtalk/updateSeeker', seekers)
    //   let p_career = this.$store.dispatch('directtalk/updateCareer', careers)
    //   let p_qualif = this.$store.dispatch('directtalk/updateQualification', qualifications)
    //   let p_column = this.$store.dispatch('directtalk/updateSeekerCustomColumns', columns)
    //   await Promise.all([p_seeker, p_career, p_qualif, p_column])
    //   this.isSaving = false
    // },
    getContent (info, key) {
      var x = eval("(" + info + ")")
      return x[key]
    },
    getInfo (info) {
      var x = eval("(" + info + ")")
      return Object.keys(x)
    },
    /**
     * 外部媒体リンク取得
     * @param {Object} applicant 応募者情報
     * @returns {string} URL
     */
    getHref (applicant) {
      let apply_url = ''
      const hrMonsterRecruitUrl = process.env.WDT_ENDPOINT + '/recruit/'
      if (
        // その他 (手動追加された応募者)
        // url、recruit_routeの両方がブランク
        (!applicant.url && !applicant.recruit_route) ||
        // スカウト返信者 (訪問者自動スカウトから追加された応募者)
        // recruit_routeに「スカウト返信者」が格納されている
        applicant.recruit_route === 'スカウト返信者' ||
        // プラスアイからの応募者
        // recruit_routeに「PLUSI」と格納されている
        applicant.recruit_route === 'PLUSI'
      ) {
        // その他、スカウト返信者、プラスアイ、不明媒体にはHRモンスター求人LPのURLを使う
        apply_url = hrMonsterRecruitUrl
      } else if (applicant.recruit_route && applicant.recruit_route.indexOf('http') < 0) {
        // recruit_routeに媒体名が格納されている (httpから始まらない)
        apply_url = applicant.recruit_route
      } else if (applicant.recruit_route) {
        // 外部媒体とHRモンスター求人からの応募者
        // recruit_routeに応募元URLまたは管理ログイン画面のURLが格納されている
        apply_url = applicant.recruit_route
      } else if (applicant.url) {
        // ロボなどの応募フォームからの応募者
        apply_url = applicant.url.replace(
          // ※ローカルの場合はポートが異なるので置換する
          process.env.OWN_ENDPOINT, process.env.WDT_ENDPOINT
        ).replace(
          // 応募フォームロボ化の場合は求人ページ詳細のパスに置換する
          'recruits/lp_robo', 'recruit/detail'
        )
      } else {
        // どこにも該当しない場合もHRモンスター求人LPにリンクする
        apply_url = hrMonsterRecruitUrl
      }

      return apply_url
    },
    /**
     * 応募媒体名取得
     * @param {Object} applicant 応募者情報
     * @returns {string} 媒体名
     */
    getPath (applicant) {
      // 媒体名取得
      let media_name = '不明媒体'

      if (!applicant.url && !applicant.recruit_route) {
        // その他 (手動追加された応募者)
        // url、recruit_routeの両方がブランク
        media_name = 'その他'
      } else if (applicant.recruit_route === 'スカウト返信者') {
        // スカウト返信者 (訪問者自動スカウトから追加された応募者)
        // recruit_routeに「スカウト返信者」が格納されている
        media_name = 'その他'
      } else if (applicant.recruit_route === 'PLUSI') {
        // プラスアイからの応募者
        // recruit_routeに「PLUSI」と格納されている
        media_name = 'PLUSI'
      } else  if (applicant.media_type) {
        // 新媒体連携処理の媒体またはHRモンスター求人からの応募者
        const media_info = this.mediaCooperationList.find((media) => media.type === applicant.media_type)
        if (media_info) {
          media_name = media_info.short_name
        }
      } else if (applicant.recruit_route) {
        // 旧媒体連携処理からの応募者
        // TODO
        // 媒体連携処理を新しい処理に移設した媒体は下記から削除すること
        if (applicant.recruit_route.indexOf('https://www.wantedly.com') >= 0) {
          media_name = 'Wantedly'
        } else if (applicant.recruit_route.indexOf('https://5159289.jp') >= 0) {
          media_name = '介護求人パーク'
//        } else if (applicant.recruit_route.indexOf('entori.jp') >= 0) {
//          media_name = 'えんと～り'
//        } else if (applicant.recruit_route.indexOf('job-list.net') >= 0) {
//          media_name = 'JOBLIST'
        } else if (applicant.recruit_route.indexOf('https://helnavi.com/') >= 0) {
          media_name = 'へるナビ'
        } else if (applicant.recruit_route.indexOf('kaigotasu.com') >= 0) {
          media_name = 'かいごたす'
        } else if (applicant.recruit_route.indexOf('kaigo.mapjob.jp') >= 0) {
          media_name = 'mapjob介護'
        } else if (applicant.recruit_route.indexOf('green-japan.com') >= 0) {
          media_name = 'Green'
//        } else if (applicant.recruit_route.indexOf('lisujob.com') >= 0) {
//          media_name = 'リスジョブ'
        } else if (applicant.recruit_route.indexOf('rtasneo.com') >= 0) {
          media_name = 'アルタスネオ'
        } else if (applicant.recruit_route.indexOf('kyujin-kaigo.net') >= 0) {
          media_name = '介護求人ネット'
        } else if (applicant.recruit_route.indexOf('bab-navi.com') >= 0) {
          media_name = 'BABナビ'
        } else if (applicant.recruit_route.indexOf('seniorjob-navi.com') >= 0) {
          media_name = 'シニア求人ナビ'
        }
      } else if (applicant.url) {
        // ロボなどの応募フォームからの応募者
        media_name = 'HRモンスター'
      }

      if (media_name === '不明媒体' && applicant.recruit_route) {
        // 不明媒体のままでrecruit_routeにデータがある場合はそのデータをそのまま表示する
        media_name = applicant.recruit_route
      }

      return media_name
    },
    getScoutFlg (sk) {
      if (sk.recruit_route) {
        if (
          sk.recruit_route === 'スカウト返信者' ||
          sk.scout_mail_flg === true
        ) {
          return sk.recruit_route
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    getManageCorp (sk) {
      // 管理企業名取得
      if (sk.other_infomation.length > 0) {
        if (sk.other_infomation[0].parameter) {
          // 値にNoneが含まれるとエラーとなるため、置換（トーコン様プラスアイ応募API経由での不正データ対応）
          sk.other_infomation[0].parameter = sk.other_infomation[0].parameter.replace("'gradyear': None,","'gradyear': '',")
          sk.other_infomation[0].parameter = sk.other_infomation[0].parameter.replace("'address': None,","'address': '',")
          let param_key = this.getInfo(sk.other_infomation[0].parameter)
          if (param_key[0] ==="管理企業") {
            let param = this.getContent(sk.other_infomation[0].parameter, param_key[0])
            return param
          }
        }
      }
      return ""
    },
    getDate (date) {
      var time = new Date(date)
      if (date == null) return null
      else return time.getFullYear() + '/' + (time.getMonth() + 1) + '/' + time.getDate() + ' ' + time.getHours() + ':' + ('00' + time.getMinutes()).slice(-2)
    },
    getOnlyDate (date) {
      const time = new Date(date)
      if (date == null) return null
      else return time.getFullYear() + '/' + (time.getMonth() + 1) + '/' + time.getDate()
    },
    getDateBack (time) {
      return time.getFullYear() + '-' + ('00' + (time.getMonth() + 1)).slice(-2) + '-' + ('00' + time.getDate()).slice(-2)
    },
    getInterviewDate (interviewHistory) {
      if (interviewHistory.length > 0) {
        if (interviewHistory[0].interview_start && interviewHistory[0].interview_end) {
          return moment(interviewHistory[0].interview_start).format('L(dd)LT～') + moment(interviewHistory[0].interview_end).format('LT')
        } else if (interviewHistory[0].interview_comment) {
          return interviewHistory[0].interview_comment
        } else if (interviewHistory[0].interview_provisional) {
          return '未設定（仮予定あり）'
        } else {
          return ''
        }
      }
    },
    getInterviewDateMagicNum (interviewHistory) {
      if (interviewHistory.length > 0) {
        if (interviewHistory[0].interview_start && interviewHistory[0].interview_end) {
          return 0
        } else if (interviewHistory[0].interview_comment) {
          return 1
        } else if (interviewHistory[0].interview_provisional) {
          return 2
        } else {
          return 3
        }
      } else {
        return 99
      }
    },
    confirmNewSeeker(seeker){
      this.$store.dispatch('directtalk/updateSeeker', {
        id: seeker.id,
        is_new: false,
        is_duplicate_seeker_flag: true,
      })
    },
    confirmResponsedSeeker(seeker){
      this.$store.dispatch('directtalk/updateSeeker', {
        id: seeker.id,
        is_new: false,
        is_responsed: false,
        is_duplicate_seeker_flag: true,
      })
    },
    // 新規メッセージ有の更新
    confirmMessageReceivedSeeker(seeker){
      this.$store.dispatch('directtalk/updateSeeker', {
        id: seeker.id,
        is_new: false,
        is_message_received: false,
        is_duplicate_seeker_flag: true,
      })
    },
    async archiveSeeker (seekers, flg) {
      for (let seeker of seekers) {
        seeker.is_archive = flg
      }
      alert((flg ? 'アーカイブ' : 'アーカイブから元に戻') + 'しました。')
      this.$store.commit('directtalk/LOAD_SEEKER', { id: 'subscribe', flg: true })
      await this.$store.dispatch('directtalk/updateSeeker', seekers)
      this.pageUpdate()
    },
    async acknowledgedSeeker (seekers, flgs) {
      for (let seeker of seekers) {
        seeker = Object.assign(seeker, flgs)
      }
      alert('選択した応募者を確認済みにしました。')
      this.$store.commit('directtalk/LOAD_SEEKER', { id: 'subscribe', flg: true })
      await this.$store.dispatch('directtalk/updateSeeker', seekers)
      this.pageUpdate()
    },
    changeRecruitmentFlow (skData) {
      let changeSeeker = skData
      this.$store.dispatch('directtalk/updateSeeker', changeSeeker)
        .then(() => {
          // tempSeekerが存在し、かつ単一のseekerの場合のみ更新
          if (this.tempSeeker && !Array.isArray(changeSeeker) && this.tempSeeker.id === changeSeeker.id) {
            this.tempSeeker = this.filteredSeekers.find((sk) => sk.id === changeSeeker.id)
          }
        })
    },
    handleBulkStageStatus(seekers) {
      this.changeModalStageStatus(seekers, true)
    },
    updateSeeker (skData) {
      // 応募者情報全体の保存
      let changeSeeker = this.$_.cloneDeep(skData)
      this.updateCareers(changeSeeker)
      this.updateQualifications(changeSeeker)
      for (let cu of changeSeeker.custom_column) {
        this.updateCustomColumn(changeSeeker, cu)
      }
      this.updateSeekerProf(changeSeeker)
      this.pageUpdate()
    },
    async updateSeekerProf (skData) {
      this.sendControlLog('応募者データ変更', '応募者管理画面にて、応募者情報の変更を行った。')
      // 応募者プロフィール(Seekerテーブル)のみ保存
      await this.$store.dispatch('directtalk/updateSeeker', skData)
    },
    createCareer(sk) {
      const career = {
        career_year: '',
        career_month: '',
        career_body: '',
        seeker: sk.id}
        this.$store.dispatch('directtalk/createCareer', career)
    },
    async updateCareers (skData) {
      // 経歴 一括で更新
      this.sendControlLog('応募者データ変更', '応募者管理画面にて、経歴情報の変更を行った。')
      await this.$store.dispatch('directtalk/updateCareer', skData.career)
    },
    createQualification (sk) {
      const qualification = {
        qualification_year: '',
        qualification_month: '',
        qualification_body: '',
        seeker: sk.id
      }
      this.$store.dispatch('directtalk/createQualification', qualification)
    },
    async updateQualifications (skData) {
      // 資格 一括で更新
      this.sendControlLog('応募者データ変更', '応募者管理画面にて、資格情報の変更を行った。')
      await this.$store.dispatch('directtalk/updateQualification', skData.qualification)
    },
    createCustomColumn (sk, col) {
      const createCustom = {
        name: col.name,
        type: 0,
        content: '',
        select_list: '',
        column: col.pk,
        id: sk.id
      }
      this.$store.dispatch('directtalk/createSeekerCustomColumns', createCustom)
    },
    async updateCustomColumn(sk, column) {
      this.sendControlLog('応募者データ変更', '応募者管理画面にて、カスタムカラム情報の変更を行った。')
      // カスタムカラム 単体で更新
      column.id = sk.id
      if (column.content) {
        await this.$store.dispatch('directtalk/updateSeekerCustomColumns', column)
      } else {
        await this.$store.dispatch('directtalk/deleteSeekerCustomColumns', column.pk)
      }
    },
    updateCustomColumnByCell (sk, c) {
      this.updateCustomColumn(sk, c)

      // レコードが複数あると更新対象が入れ替わってしまうので、渡されたデータをそのまま更新する
      // // カスタムカラム セルの変更から更新
      // let content = sk.custom_column.find((content) => content.column === col.pk)
      // if (content) {
      //   content.name = col.name
      //   this.updateCustomColumn(sk, content)
      // }
    },
    openActionCheckModal (data) {
      this.$refs.actchk.sk     = data.sk
      this.$refs.actchk.action = data.action
      this.$refs.actchk.active = true
    },
    openActionTableModal (data) {
      this.$refs.acttbl.sk     = data
      this.$refs.acttbl.active = true
    },
    deleteSeekerFile (id) {
      this.$store.dispatch('directtalk/deleteSeekerFiles', id)
      this.isOpenModalDelete = false
    },
    changeModalDelete (deleteData) {
      this.$refs.delete.seekerFile = deleteData.seekerFile
      this.$refs.delete.seeker = deleteData.seeker
      this.isOpenModalDelete = deleteData.flg
    },
    changeModalSetDate (flg, sk) {
      if (this.emailTemplates.length == 0) {
        let createEmailTemplate = {
          name       : 'no title',
          from_email : '',
          to_email   : '',
          cc_email   : '',
          template   : '',
          company    : this.user.companyPK,
          robo       : '',
        }
        this.$store.dispatch('auth/createCompanyEmailTemplate', createEmailTemplate)
        .then(() => {
          this.selectSeeker   = sk
          this.isModalSetDate = flg
        })
      } else {
        this.selectSeeker   = sk
        this.isModalSetDate = flg
      }
    },
    changeModalChangeDate (flg, sk, interviewhistory) {
      if (this.emailTemplates.length == 0) {
        let createEmailTemplate = {
          name       : 'no title',
          from_email : '',
          to_email   : '',
          cc_email   : '',
          template   : '',
          company    : this.user.companyPK,
          robo       : '',
        }
        this.$store.dispatch('auth/createCompanyEmailTemplate', createEmailTemplate)
        .then(() => {
          this.selectSeeker   = sk
          this.isModalChangeDate = flg
          this.interviewHistory = interviewhistory
        })
      } else {
        this.selectSeeker   = sk
        this.isModalChangeDate = flg
        this.interviewHistory = interviewhistory
      }
    },
    changeModalCreateDate (flg, sk) {
      if (flg) {
        this.isModalCreateDate = flg
        if (this.emailTemplates.length == 0) {
          let createEmailTemplate = {
            name       : 'no title',
            from_email : '',
            to_email   : '',
            cc_email   : '',
            template   : '',
            company    : this.user.companyPK,
            robo       : '',
          }
          this.$store.dispatch('auth/createCompanyEmailTemplate', createEmailTemplate)
          .then(() => {
            this.createDateinfo = {
              title: sk.name + "様面接",
              memo: null,
              mtg_time_hour: 1,
              mtg_time_minute: 0,
              holiday_list: [],
              after: 1,
              user_hash: [],
              user_hash_sub: [],
              user_hash_share: [],
              user_hash_departments: [],
              user_hash_positions: [],
              user_hash_departments: [],
              method: 0,
              interval: 0,
              reminder_flg: false,
              reminder_day: 1,
              reminder_before_flg: false,
              reminder_before_minute: 30,
              reminder_member_flg: false,
              reminder_title: null,
              reminder_to: null,
              reminder_cc: null,
              reminder_content: null,
              is_AND: true
            }
            this.selectSeeker = sk
            this.sendEmailTemplate = this.$_.cloneDeep(this.emailTemplates[0])
            this.sendEmailTemplate.seeker = sk.id
            this.sendEmailTemplate.to_email = sk.email
            this.sendEmailTemplate.seeker_name = sk.name
          })
        } else {
          this.createDateInfo = {
            title: sk.name + "様面接",
            memo: null,
            mtg_time_hour: 1,
            mtg_time_minute: 0,
            holiday_list: [],
            after: 1,
            user_hash: [],
            user_hash_sub: [],
            user_hash_share: [],
            user_hash_departments: [],
            user_hash_positions: [],
            user_hash_departments: [],
            method: 0,
            interval: 0,
            reminder_flg: false,
            reminder_day: 1,
            reminder_before_flg: false,
            reminder_before_minute: 30,
            reminder_member_flg: false,
            reminder_title: null,
            reminder_to: null,
            reminder_cc: null,
            reminder_content: null,
            is_AND: true
          }
          this.selectSeeker = sk
          this.sendEmailTemplate = this.$_.cloneDeep(this.emailTemplates[0])
          this.sendEmailTemplate.seeker = sk.id
          this.sendEmailTemplate.to_email = sk.email
          this.sendEmailTemplate.seeker_name = sk.name
        }
      } else {
        this.isModalCreateDate = flg
      }
    },
    cancelModalBulkAction (boolean) {
      this.isOpenModalBulkAction = boolean
    },
    cancelModalSelectEmail (boolean) {
      this.isOpenModalSelectEmail = boolean
    },
    clickBulkSendEmail (menuType) {
      if (menuType === 'email') {
        this.$emit('sendEmail', {sk: null, bulk: true}, false)
      }
    },
    clickBulkSendSMS () {
      this.$emit('sendSMS', {sk: null, bulk: true})
    },
    clickBulkManage (menuType) {
      if (menuType === 'manage') {
        this.$emit('BulkManage', {sk: null, bulk: true}, false)
      }
    },
    checkbox (sk, bool) {
      this.$emit('checkbox', {sk: sk, isCheck: bool})
    },
    openSendEmailMenu(sk, notOpenMenu) {
      this.$emit('sendEmail', {sk: sk}, notOpenMenu)
    },
    openSendSMSMenu(sk) {
      this.$emit('sendSMS', {sk: sk})
    },
    openEmailModal (sk) {
      this.isOpenModalSelectEmail = true
      this.selectEmailSeeker = sk
    },
    openMessageModal (sk) {
      this.$emit('selectRoom', sk)

      this.isOpenModalMessage = true
      this.selectEmailSeeker = sk
    },
    isColInSkInfo (sk, col) {
      return this.$_.includes(
        sk.custom_column.map((obj) => {return obj.column}),
        col.pk
      )
    },
    isLastCol (sk, col, selCol) {

      let res = this.$_.filter(
        sk.custom_column,
        (obj) => {
          return obj.column === col.pk
        }
      )
      if (res.length > 0) {
        return res.sort((a, b) => {
          if (a.pk > b.pk) return -1
          else if (a.pk < b.pk) return 1
          else return 0
        })[0].pk === selCol.pk
      } else {
        return false
      }
    },
    /** 回答閲覧 */
    viewAnswer (seeker) {
      // 回答閲覧ダイアログ表示
      this.selectSeeker     = seeker
      this.isViewDialogOpen = true
    },
    updateRecordingAnswer (data) {
      this.$store.dispatch('directtalk/updateRecordingAnswer', data)
        .then(() => {
          this.$refs.interview.setInterviewDatas()
        })
    },
    updateRecordingReadAnswer (data) {
      this.$store.dispatch('directtalk/updateRecordingReadAnswer', data)
    },
    viewClose () {
      this.selectSeeker     = null
      this.isViewDialogOpen = false
    },
    changeModalDetailSeeker (sk, flg) {
      this.tempSeeker = sk
      this.isModalDetailSeeker = flg
      if (this.isModalDetailSeeker) this.openSendEmailMenu(sk, true)
    },
    changeModalStage (sk, flg, selectData) {
      this.tempSeeker = sk
      this.isModalStage = flg
      this.tempStg = selectData
    },
    changeModalStatus (sk, flg, stsData) {
      this.tempSeeker = sk
      this.isModalStatus = flg
      this.tempSts= stsData
    },
    changeModalStageStatus (seekers, flg) {
      if (Array.isArray(seekers)) this.tempSeekers = seekers
      else this.tempSeekers = [seekers]
      this.isModalStageStatus = flg
    },
    async logicalDeleteSeeker (seekers) {
      if (window.confirm("本当に削除しますか？")) {
        for (let seeker of seekers) {
          seeker.is_delete_apply = true
        }
        this.$store.commit('directtalk/LOAD_SEEKER', { id: 'subscribe', flg: true })
        await this.$store.dispatch('directtalk/updateSeeker', seekers)
        this.pageUpdate()
      }
    },
    getResizeBorder () {
      let height = 0
      if (document.getElementById('rec-tbl')) {
        height = document.getElementById('rec-tbl').offsetHeight
      }
      return {
        'top': '0px',
        'right': '-4px',
        'width': '8px',
        'height': height + 'px',
        'position': 'absolute',
        'cursor': 'col-resize',
        'backgroundColor': 'transparent',
        'userSelect': 'none'
      }
    },
    startResize (e, pk) {
      const elm = document.getElementById('col-th-' + pk)
      if (elm.className !== "fixed-col-ZZ") {
        this.curCol = document.getElementById('col-th-' + pk)
        this.curColPK = pk
        this.nxtCol = this.curCol.nextElementSibling
        this.pageX = e.pageX
        this.curColWidth = this.curCol.offsetWidth
      } else {
        alert("固定状態ではカラム幅の変更ができません")
      }
    },
    changeResize (e) {
      if (this.curCol) {
        let diffX = e.pageX - this.pageX
        let w = (this.curColWidth + diffX) + 'px'
        this.curCol.style.width = w
        localStorage.setItem('col-' + this.curColPK, w)
      }
    },
    endResize () {
      this.curCol      = null
      this.curColPK      = null
      this.pageX       = null
      this.curColWidth = null
      this.nxtColWidth = null
    },
    getColumnWidth (col) {
      let width = '150px'
      if (col.template_type == 0) {
        width = Number(col.name.length * 16.5 + 60) + 'px'
      }
      if (col.template_type == 5 || col.template_type == 17) {
        width = '108px'
      }
      if (col.template_type == 8) {
        width = '302px'
      }
      if (col.template_type == 9) {
        width = '96px'
      }
      if (col.template_type == 14 || col.template_type == 15 || col.template_type == 28) {
        width = '350px'
      }
      if (
        col.template_type == 11
        || col.template_type == 18
        || col.template_type == 19
        || col.template_type == 20
      ) {
        width = '128px'
      }
      if (col.template_type == 21 ) {
        width = '350px'
      }
      if (col.template_type == 22 ) {
        width = '200px'
      }
      if (col.template_type == 30 ) {
        width = '100px'
      }
      let wLocalStg = localStorage.getItem('col-' + col.pk)
      if (wLocalStg != null) {
        width = wLocalStg
      }
      return width
    },
    updateStickyStyle () {
      for (let col of this.companyColumnSetting) {
        if (col.is_sticky) {
          const common_style = {
            top: '0px',
            left: Number(this.getColSpanSize(col)) + 'px'
          }
          const header_style = {
            ...common_style,
            width: this.getColumnWidth(col),
            'z-index': Number(10001 - col.order_type),
          }
          const data_style = {
            ...common_style,
            'z-index': Number(10000 - col.order_type - 1),
          }
          // 変化があったときだけ更新する
          if (!this.$_.isEqual(this.stickyHeaderStyle[col.pk], header_style)) {
            this.$set(this.stickyHeaderStyle, col.pk, header_style)
          }
          if (!this.$_.isEqual(this.stickyDataStyle[col.pk], data_style)) {
            this.$set(this.stickyDataStyle, col.pk, data_style)
          }
        }
        else {
          const no_style = {
            width: this.getColumnWidth(col)
          }
          if (!this.$_.isEqual(this.stickyHeaderStyle[col.pk], no_style)) {
            this.$set(this.stickyHeaderStyle, col.pk, no_style)
          }
          if (!this.$_.isEqual(this.stickyDataStyle[col.pk], no_style)) {
            this.$set(this.stickyDataStyle, col.pk, no_style)
          }
        }
      }
    },
    getColSpanSize (c) {
      const action_elem = document.getElementById('col-th-individual-action')
      const selectbox_elem = document.getElementById('col-th-select-box')
      if (!selectbox_elem || !action_elem) return 0

      let width_sum = this.companyColumnSetting
        .filter((setting) => {
          return setting.order_type < c.order_type && !setting.is_disabled
        })
        .map((setting) => {
          let elem = document.getElementById('col-td-' + setting.pk)
          if (elem) return elem.getBoundingClientRect().width
          else return 0
        })
        .reduce((sum, item) => sum+item, 0)

      return selectbox_elem.getBoundingClientRect().width + action_elem.getBoundingClientRect().width + width_sum
    },
    getProgressText (value) {
      if (value != null) {
        for (const op of this.options) {
          if (op.value === value) return op.text
        }
      }
      return ''
    },
    getChatBotName (bot) {
      let chatbot_name = ""
      for (const cb of this.chatbots){
        if(cb.bot_id === bot){
          chatbot_name = cb.name
        }
      }
      return chatbot_name
    },
    // フィルタリング後のラベル表示：アクションカラムのフィルタリングで選択された値に応じて表示を出しわける
    getSelectName (type) {
      if(type === 0){
        return " 指定なし"
      }else if(type === 1){
        return " 未返信"
      }else if(type === 2){
        return " 未送信"
      }else if(type === 3){
        return " 未開封"
      }else if(type === 4){
        return " 開封済"
      }else if(type === 5){
        return " 未リンク"
      }else if(type === 6){
        return " 未回答"
      }else if(type === 7){
        return " 回答済"
      }else{
        return ""
      }
    },
    getCheckBoxValue (sk) {
      let index = this.$_.findIndex(this.bulkSeekerList, (obj) => {return sk.id === obj.id})
      return index >= 0
    },
    // 重複フラグの定義（同じ会社の応募者で、電話番号またはEmailが被っている応募者）
    duplicatedApplicants(sk) {
      // メールアドレスと電話番号のIDをSetとして保持しておく
      const emailIds = new Set(sk.duplicate_email.map(email => email.id));
      const telIds = new Set(sk.duplicate_tel.map(tel => tel.id));

      // メールアドレスまたは電話番号が重複しているデータをフィルタリング
      const matchedEmail = sk.duplicate_email.filter(email => emailIds.has(email.id));
      const matchedTel = sk.duplicate_tel.filter(tel => telIds.has(tel.id));

      // 両方のリストから重複を除外したデータを取得
      const matched = [...matchedEmail, ...matchedTel.filter(tel => !emailIds.has(tel.id))];

      if (matched.length > 0) {
        return matched;
      } else {
        return [];
      }
    },
    blacklistedApplicant(sk) {
      return sk.applicant_blacklist_cls > 0;
    },
    cancelModalMessage (boolean) {
      this.isOpenModalMessage = boolean
    },
    getDispNum () {
      let prefix = ''
      if (this.filtered.length > 0) {
        // 絞り込み時
        prefix = '絞り込み件数'
      } else {
        prefix = '総件数'
      }
      // 表示範囲は必要になったら表示する
      // // 表示開始番号
      // const startNum = ((Number(this.seekersPages) - 1) * Number(this.perPage)) + 1
      // // 表示終了番号
      // // 最終ページの最大件数が総件数を超える場合は総件数を表示する
      // // 超えない場合はそのページの最大件数を表示する
      // const endNum = this.seekersPages * this.perPage > this.filteredSeekersNum ? this.filteredSeekersNum : (startNum - 1) + Number(this.perPage)
      // 総件数
      const totalNum = this.filteredSeekersNum

      // return prefix + '：' + totalNum + '件 / 表示：' + startNum + ' - ' + endNum
      return prefix + '：' + totalNum + '件'
    },
    getIconURL (icon) {
      if (icon.image_data) {
        return icon.image_data
      } else {
        return require('@/assets/template/robot.png')
      }
    },
    // フィルタリングを表示するかどうかの真偽値を返す
    canFilter (templateType) {
      return templateType !== 8 && templateType !== 18 && templateType !== 23
    },
    // ファイルリストを表示する
    showFileList(sk, event) {
      this.currentSeekerFiles = sk.seeker_files;
      this.showingFileList = true;

      // td 要素の位置とサイズを取得
      const tdElement = event.target.closest('td');
      if (tdElement) {
        const rect = tdElement.getBoundingClientRect();

        // ポップオーバーの高さを取得（または推定値を使用）
        const popoverHeight = 50;

        // スクロール可能な親要素を取得
        const scrollParent = this.getScrollParent(tdElement);
        const scrollTop = scrollParent ? scrollParent.scrollTop : 0;

        // ポップオーバーの位置を計算
        let top = rect.bottom - popoverHeight - 10; // 10pxの余白
        let left = rect.left - 100; // 100px左にずらす

        // 画面上端でのはみ出しを防ぐ
        if (top < 0) {
          top = rect.bottom + 10; // ボタンの下に表示
        }

        // ポップオーバーの位置を設定
        this.popoverStyle = {
          position: 'absolute',
          top: `${top}px`,
          left: `${left}px`,
          zIndex: 1000
        };
      }

      this.clearHideTimeout();  // 非表示タイマーをクリア
      this.startHideTimeout();  // 非表示タイマーを開始
    },
    getScrollParent(element) {
      if (!element) return document.documentElement;
      
      const isScrollable = (el) =>
        ['auto', 'scroll'].includes(window.getComputedStyle(el).overflowY) && el.scrollHeight > el.clientHeight;

      let parent = element.parentElement;
      while (parent) {
        if (isScrollable(parent)) return parent;
        parent = parent.parentElement;
      }

      return document.documentElement;
    },

    // 非表示タイマーをクリアする
    clearHideTimeout() {
      clearTimeout(this.hideTimeout);
    },
    // 非表示タイマーを開始する
    startHideTimeout() {
      this.hideTimeout = setTimeout(() => {
        this.showingFileList = false;
      }, 1000);
    },
    // ファイルリストポップオーバーを閉じる
    closeFileListPopover() {
      this.showingFileList = false;
    },
    // ファイルモーダルを開く
    openFileModal(file, event) {
      // Ctrlキー（Macの場合はCommandキー）が押されているかチェック
      const isCtrlClick = event && (event.ctrlKey || event.metaKey);

      if (isCtrlClick && file.file) {
        // 新しいタブでファイルを開く
        window.open(file.file, '_blank');
      } else {
        // 通常の動作：子モーダルを開く
        this.selectedFileModal = file;
        this.isFileModalOpen = true;
      }
    },
    // ファイルモーダルを閉じる
    closeFileModal() {
      this.isFileModalOpen = false;
    },
    // 詳細モーダルの状態を変更する
    changeModalDetailSeeker(sk, flg) {
      this.tempSeeker = sk;
      this.isModalDetailSeeker = flg;
      if (this.isModalDetailSeeker) {
        this.openSendEmailMenu(sk, true);
      }
      this.showingFileList = false;
    },
    /**
      * セル内容のポップオーバー表示を制御するメソッド
      * @param {string} content - 表示するセルの内容
      * @param {Event} event - マウスイベント
      */
    showCellContent(content, event) {
      if (!content) return;
      
     // クリックされたセルの位置情報を取得
      const cellRect = event.target.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;  // ← 追加：ウィンドウの高さを取得
      
     // ポップオーバーの基本サイズと余白を設定
      const popoverWidth = 300;  // ポップオーバーの基本幅
      const popoverHeight = 50;
      const gap = 2; // セルとポップオーバーの間隔
      
     // 初期位置（セルの左側）を設定
      let left = cellRect.left - 60;
      
      // 画面右端付近かどうかをチェック
      const isNearRightEdge = (cellRect.right + popoverWidth + gap) > windowWidth;
      
      if (isNearRightEdge) {
        // 右端付近の場合は左側に表示
        left = cellRect.left - popoverWidth - (gap * 60);
      }

      // 左端調整（左にはみ出す場合）
      if (left < 0) {
        left = gap;
      }

      let top = cellRect.bottom + gap;  // セルの下端 + 間隔
      // ← 追加：画面下端のチェック
      const isNearBottomEdge = (top + popoverHeight + gap) > windowHeight;
      if (isNearBottomEdge) {
        // 下端に近い場合は、セルの上に表示
        top = cellRect.top - popoverHeight - gap;
      }

     // ポップオーバーのスタイルを設定
      this.cellPopoverStyle = {
        position: 'absolute',
        top: `${top}px`,  // ← 変更：計算された垂直位置を使用
        left: `${left}px`,
        zIndex: 1000
      };
      
      this.currentCellContent = content;
      this.showingCellContent = true;
      
      this.clearHideCellTimeout();
    },

    /**
      * マウスがセルから離れた時の処理
      * ポップオーバーにホバーしていない場合のみ非表示タイマーを開始
      */
    handleMouseLeave() {
      // ポップオーバーにホバーしていない場合のみ非表示タイマーを開始
      if (!this.isPopoverHovered) {
        this.startHideCellTimeout();
      }
    },

    /**
      * ポップオーバーにマウスが入った時の処理
      * @param {Event} event - マウスイベント
      */
    handlePopoverEnter(event) {
      this.isPopoverHovered = true;
      this.clearHideCellTimeout();
    },

    /**
      * ポップオーバーからマウスが離れた時の処理
      * @param {Event} event - マウスイベント
      */
    handlePopoverLeave(event) {
      this.isPopoverHovered = false;
      this.startHideCellTimeout();
    },

    /**
      * ポップオーバー非表示用タイマーの開始
      * 200ms後にポップオーバーを非表示にする
      */
    startHideCellTimeout() {
      this.hideTimeout = setTimeout(() => {
        if (!this.isPopoverHovered) {  // ホバー状態を再確認
          this.showingCellContent = false;
        }
      }, 200);
    },
    /**
      * ポップオーバー非表示用タイマーのクリア
      */
    clearHideCellTimeout() {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
      }
    },
    // ファイルリストポップオーバーを閉じる
    closeCellContentPopover() {
      this.showingCellContent = false;
    },
    bgColor(color) {
      return color ? color : '#ffffff';
    },
    textColor(color) {
      return this.isDark(this.bgColor(color)) ? '#ffffff' : '#000000';
    },
    isDark(color) {
      const rgb = this.hexToRgb(color);
      const brightness = 0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b;
      return brightness < 128;
    },
    hexToRgb(hex) {
      let r = 0, g = 0, b = 0;
      if (hex.length === 4) {
        r = parseInt(hex[1] + hex[1], 16);
        g = parseInt(hex[2] + hex[2], 16);
        b = parseInt(hex[3] + hex[3], 16);
      } else if (hex.length === 7) {
        r = parseInt(hex[1] + hex[2], 16);
        g = parseInt(hex[3] + hex[4], 16);
        b = parseInt(hex[5] + hex[6], 16);
      }
      return { r, g, b };
    }
  },
  /**
  * コンポーネント破棄時の処理
  * タイマーをクリアしてメモリリークを防止
  */
  beforeDestroy() {
    this.clearHideCellTimeout();
  },
}
</script>

<style lang="scss" scoped>
.recruit-table {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0px;
  border-bottom: solid thin #a00;
  tr:nth-child(odd) td {
    background:#ffeeff;
  }
  tr:nth-child(even) td {
    background:#fafafa;
  }
  td, th {
    max-width: 100px;
    padding: 8px;
    margin: auto;
    width: 200px;
    max-width: 500px;
    font-size: smaller;
    text-align: center;
    border: solid thin #a00;
    border-right: none;
    border-bottom: none;
  }
  td:nth-child(3) {
    border-left: none;
  }
  th:nth-child(3) {
    border-left: none;
  }
  td {
    overflow: hidden;
    text-align: center;
    padding: 8px;
    max-height: 50px;
    .icons {
      display: block;
      text-align: left;
      padding: 8px 8px 0px 8px;
      height: 30px;
    }
    .name {
      display: block;
      white-space: nowrap;
      color: rgb(170, 0, 0);
      text-align: left;
      padding: 0px 8px 8px 8px;
      width: 100%;
      text-decoration: underline;
    }
    .reki-col {
      height: 50px;
      overflow: auto;
    }
  }
  th {
    min-height: 50px;
    height: 50px;
    max-height: 50px;
    background:#ffeeff;
    white-space: nowrap;
    vertical-align: middle;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 10000;
    border-bottom: solid thin #a00;
  }
  .header-col {
    position: relative;
  }
  .fixed-col-01 {
    position: sticky;
    top: 0;
    left: 0;
    width: 40px;
    z-index: 2147483647;
    &:before{
      content: "";
      position: absolute;
      top: -1px;
      left: -1px;
      width: 100%;
      height: 100%;
    }
  }
  .fixed-col-02 {
    position: sticky;
    top: 0px;
    left: 0;
    width: 128px;
    z-index: 10003;
    &:before{
      content: "";
      position: absolute;
      top   : -1px;
      left  : -1px;
      width : 100%;
      height: 100%;
    }
  }
  .fixed-col-03 {
    position: sticky;
    top: 0;
    left: 40px;
    width: 128px;
    z-index: 2147483647;
    border-right: solid thin #a00;
    &:before{
      content: "";
      position: absolute;
      top   : -1px;
      left  : -1px;
      width : 100%;
      height: 100%;
    }
  }
  .fixed-col-03-not-archive {
    width: 166px;
  }
  .fixed-col-03-archive {
    width: 166px;
  }
  .fixed-col-04 {
    position: sticky;
    left: 40px;
    border-right: solid thin #a00;
    &:before{
      content: "";
      position: absolute;
      top   : -1px;
      left  : -1px;
      width : 100%;
      height: 100%;
    }
  }
  .fixed-col-04-not-archive {
    width: 128px;
  }
  .fixed-col-04-archive {
    width: 166px;
  }
  .fixed-col-ZZ {
    position: sticky;
    border-right: solid thin #a00;
    z-index: 100;
    &:before{
      content: "";
      top   : -1px;
      left  : -1px;
      width : 100%;
      height: 100%;
    }
  }
}
.recruit-box {
  width: calc(100% - 20px);
  height: calc(100vh - 158px);
  margin: 0 auto;
  background: #ffeeff;
  border-right: solid thin #a00;
}
.recruit-header {
  margin: 0 auto;
  margin-top: 8px;
  width: calc(100% - 20px);
  height: 50px;
  display: flex;
  align-items: center;
  overflow-x: scroll;
  border: solid thin #a00;
  border-bottom: none;
  background: #ffeeff;
}
.recruit-footer {
  width: calc(100% - 20px);
  background: #ffeeff;
  margin: 0 auto;
  height: 50px;
  display: flex;
  align-items: center;
  border: solid thin #a00;
}
.main-box {
  width: 100%;
  height: calc(100% - 120px);
  padding: 0;
}
.cell-textbox {
  min-width: 100px;
  min-height: 50px;
  background: transparent; border: none; border-radius: 0; -webkit-appearance: none; box-shadow: none; height: 100%; width: 100%;
}
.cell-content-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}
.filter-button {
  position: absolute;
  right: 0;
  top: 7px;
  font-size: 14px;
  margin-left: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  outline: 0;
}
.table-list {
  border: solid thin #ccc;
  height: calc(100vh - 180px);
  overflow: scroll;
}
.file-box {
  font-size: smaller;
  overflow: hidden;
  width: 100%;
  height: 24px;
  display: inline-flex;
  margin-bottom: 4px;
  img {
    width: 16px; height: 16px; margin-right: 4px;
  }
  span {
    cursor: pointer; color: red; margin-right: 8px;
  }
  a {
    display: block;
    width: 150px;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
.export-box {
  height: calc(100vh - 130px);
  width: 100%;
}
.export-list {
  margin: 20px;
  margin-right: 5px;
  margin-left:  10px;
  height: calc(100% - 40px);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background: rgba(200, 200, 200, 0.5);
  border-radius: 10px;
}
.export-list-header {
  background: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  width: 200px;
  height: 40px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  color: white;
  font-size: 16px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.export-list-body {
  border-radius: 10px;
  width: 190px;
  text-align: center;
  color: black;
  font-size: 16px;
  margin: 5px;
  margin-bottom: 0;
  padding: 10px;
  background: white;
  min-height: 44px;
}
.export-header {
  height: 50px;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.add-box {
  margin: 20px;
  margin-left: 5px;
  margin-right: 10px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  /* padding: 20px; */
  width: 210px;
  height: 40px;
}
.date-box {
  width: 40%;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between
}
.option-box {
  width: 60%;
  padding-right: 10px; 
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px;
  overflow: scroll;
}
.resume-btn {
  border-radius: 50%;
  height: 36px;
  width: 36px;
  font-size: 16px;
}

.wrapper-cover-img {
  position: relative;
}

.input-box {
  text-align: left;
  width: 100%;
  display: flex;
  border-bottom: solid thin #ccc !important;
  border-right: solid thin #ccc !important;
  border-left: solid thin #ccc !important;
}
.input-label {
  width: 30%;
  border-right: solid thin #ccc !important;
  background: rgb(250, 230, 230) !important;
  padding: 8px !important;
}
.input-modal {
  width: calc(100% - 30%);
  height: 40px;
  color: #222 !important;
  font-size: 16px !important;
  background: #FEFEFE !important;
  padding: 8px !important;
  border-radius: 0;
  border: none;
  box-shadow: none;
}

.table-box {
  width: 100%;
}
.table-box-header {
  border: solid thin #ccc !important;
  background: rgb(250, 230, 230) !important;
  color: #222;
  padding: 8px !important;
}
.input-table {
  height: 40px;
  color: #222 !important;
  font-size: 16px;
  background: #FEFEFE !important;
  padding: 8px !important;
  border-radius: 0;
  box-shadow: none !important;
}
.container-birth{
  display: flex
}

.right-enter-active, .right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.right-enter, .right-leave-to {
  transform: translateX(100vw) translateX(0px);
}

.tooltip{
  position : relative;
  cursor   : pointer;
  display  : inline-block;
}
.fixed-tooltip{
  position : fixed;
  cursor   : pointer;
  display  : inline-block;
}
.tooltip-mail, .tooltip-message, .tooltip-archive {
  display       : none;
  position      : absolute;
  color         : #fff;
  background    : #363636;
  padding       : 8px;
  font-size     : 14px;
  border-radius : 5px;
  width         : 100px;
  z-index       : 10;
}
.tooltip-float-wrapper {
  position: fixed;
  z-index: 10010;
  pointer-events: none;
}
.tooltip-float {
  display       : inline-block;
  position      : absolute;
  color         : #fff;
  background    : #363636;
  padding       : 8px;
  font-size     : 12px;
  border-radius : 5px;
  min-width     : 110px;
  height        : 36px;
  z-index       : 10;
  text-align: center;
  white-space: nowrap;
}
.tooltip-mail:before {
  content    : "";
  position   : absolute;
  top        : -20px;
  left       : 5px;
  border     : 15px solid transparent;
  border-top : 15px solid #363636;
  transform  : rotateZ(180deg);
}
.tooltip:hover .tooltip-mail{
  display : inline-block;
  top     : 34px;
  left    : 0px;
}
.tooltip-message:before {
  content    : "";
  position   : absolute;
  top        : -20px;
  left       : 35px;
  border     : 15px solid transparent;
  border-top : 15px solid #363636;
  transform  : rotateZ(180deg);
}
.tooltip:hover .tooltip-message{
  display : inline-block;
  top     : 34px;
  left    : -30px;
}
.tooltip-archive:before {
  content    : "";
  position   : absolute;
  top        : -20px;
  right      : 5px;
  border     : 15px solid transparent;
  border-top : 15px solid #363636;
  transform  : rotateZ(180deg);
}
.tooltip:hover .tooltip-archive{
  display : inline-block;
  top     : 34px;
  right   : -4px;
}
.tooltip-float:after {
  content    : "";
  position   : absolute;
  top        : 27px;
  left       : 10px;
  border     : 15px solid transparent;
  border-top : 15px solid #363636;
}
.nemo-btn {
  height: 36px;
  width:  36px;
  border-radius: 50%;
  margin: 4px 21px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: 1s;
  cursor: pointer;
}
.-odd {
  background: linear-gradient(145deg, #e1e1e1, #ffffff);
  box-shadow: 5px 5px 10px #c1c1c1, 
              -5px -5px 10px #ffffff;
}
.-even {
  background: linear-gradient(145deg, #e6d6e6, #ffffff);
  box-shadow: 5px 5px 10px #c4b7c4, 
              -5px -5px 10px #ffffff;
}
.-odd:active {
  background: #fafafa;
  box-shadow: inset 5px 5px 10px #d2d2d2, 
            inset -5px -5px 10px #ffffff;
}
.-even:active {
  background: #ffeeff;
  box-shadow: inset 5px 5px 10px #d6c8d6, 
              inset -5px -5px 10px #ffffff;
}
.top-menu {
  width: calc(100% - 20px);
  display: flex;
  padding: 10px;
  justify-content: left;
  .button-wrapper-tables {
    min-width: 500px;
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
  }
  .button-wrapper-manage {
    max-width: 300px;
    min-width: 200px;
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
  }
  .button-wrapper {
    min-width: 300px;
    display: flex;
    margin-left: auto;
    flex-wrap: wrap;
  }
  .tabs {
    margin: 0;
    ul {
      li {
        a {
          width: 102px;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
  }
  button {
    margin-left: 8px;
    height: 32px;
    &.-no1 {
      border: solid 1.5px #d6d;
    }
    &.-no2 {
      border: solid 1.5px #6d6;
    }
    &.-no3 {
      // margin-left: 40px;
      border: solid 1.5px rgb(187, 187, 85);
    }
  }
}
.select-recruit {
  width: 100%;
  font-size: 13.33px;
  z-index: 20;
  /deep/ .vs__selected-options {
    flex-wrap: nowrap;
  }
}
.select-robotalk {
  width: 100%;
  font-size: 13.33px;
  z-index: 20;
  /deep/ .vs__selected-options {
    flex-wrap: nowrap;
  }
}
.filter-custom-free {
  margin-top: 8px;
  max-height: 200px;
  max-width: 300px;
  overflow-y: scroll;
  border: solid 1px black;
  text-align: left;
}
.individual-action {
  button {
    border: none;
    border-radius: 4px;
    width: 32px;
    height: 32px;
    font-size: 14px;
    margin-left: 4px;
  }
}
.custom-box {
  width: 90%;
  background: transparent;
  border: none;
  border-radius: 0;
  -webkit-appearance: none;
  box-shadow: none;
  height: 32px;
  border-bottom: dotted thin #ccc;
}
table {
  border-collapse: separate;
  border-spacing: 0; 
}
.table-header {
  width: 100%;
  th {
    position: sticky;
    top: 0;
    background-color: white;
    border-top: 1px lightgray solid;
    border-bottom: 1px lightgray solid;
  }
}
.chatbot-icon-small {
  height: 19px;
  width:  19px;
  margin: auto;
  border-radius: 50%;
  background: white;
  border: solid thin #ccc;
}

.duplicate-flag-wraper {
  padding-left: 24px;
  display: flex;
  justify-content: left;
  align-items: center;
}
.duplicate-flag {
  font-size: 14px;
}
/* ファイルリストのコンテナ */
.file-list-container {
  position: relative;
}
/* ファイルリストのオーバーレイ */
.file-list-overlay {
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px;
  max-height: 200px;
  overflow-y: auto;
  min-width: 200px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}
/* ファイルボックス */
.file-box {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
/* ファイルアイコン */
.file-icon {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
/* ファイルリンク */
.file-link {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
}
/* フェードアニメーション */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Manage/ManageView.vue